import {
  // GoogleMap,
  // InfoWindow,
  // MarkerClusterer,
  useLoadScript,
  MarkerProps,
  InfoWindowProps,
  MarkerClustererProps,
  GoogleMapProps,
} from "@react-google-maps/api";
import {
  useCallback,
  useEffect,
  useState,
  useRef,
  MutableRefObject,
  RefObject,
  createRef,
  memo,
  useContext,
} from "react";
import { useMutation, useQuery } from "react-query";
import ListingCard from "./ListingCard/ListingCard2point0";
import SideNav from "./SideNav/SideNav";
import {
  FilterShell,
  HeaderHolder,
  MainHeader,
  MainHolder,
  Results,
  ResultsAndMap,
  StaticHolder,
  TopFiltersHolder,
  FilterHolder,
  ListingsSpinnerHolder,
  PaginationButtonHolder,
  DescriptionWrapper,
  SmallFancyLink,
  HeaderStaticDesc,
  SSDetails,
  ModalBodyText,
  Floater,
  RemoveBoundaryHolder,
  RemoveBoundaryInner,
  Map,
  Suggestions,
  SpacerCell,
  ContentCell,
  StyledRow,
  IconSpan,
  BoldSpan,
  TextSpan,
  ListingCardHolderGrid,
  FilterHeader,
  InputWrapper,
  IncrementHolder,
  FixedSearcherHolder,
  FixedSearcherMaxW,
  PriorityListingHolderGrid,
} from "../styles/ListingsStyles";
import { useAuth } from "../utils/auth/newAuth";
// import { GlobalStateContext } from "../utils/contexts/QueryStateContext";
// import savedSearch from '../public/images/search/savedSearch.svg'
import {
  Box,
  Flex,
  Text,
  Button,
  Popover,
  PopoverTrigger,
  PopoverHeader,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  PopoverFooter,
  CheckboxGroup,
  Checkbox,
  Spinner,
  InputGroup,
  Input,
  IconButton,
  RadioGroup,
  Radio,
  Stack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  useDisclosure,
  ModalBody,
  ButtonGroup,
  useToast,
  Select as ChakraSelect,
  Collapse,
  TagLabel,
  TagCloseButton,
  Tag,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Grid,
  DrawerFooter,
  DrawerCloseButton,
  Alert,
  Switch,
  FormLabel,
} from "@chakra-ui/react";
import { AuthModal } from "./Auth/withAuthModal";
import styles from "./UI/Forms/Input/HiLoStyles.module.css";

import Link from "next/link";
import slugify from "slugify";
const placeholder = "/images/placeholder-image.svg";
import NextImage from "next/legacy/image";
import { getToken } from "../src/config/firebase";
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete";
import { RiBuilding2Fill } from "react-icons/ri";
import {
  propertyTypeOptions,
  dateUploadedOptions,
  sortByOptions,
  transactionTypeOptions,
  SavedSearchFrequencyOptions,
  groupedSubtype,
  subTypeOptions,
  groupedBusiness,
  AllBusiness,
  postedByOptions,
  provinceSlugs,
} from "./Listing/data";
import { useRouter } from "next/router";
import { Field, Formik, useField, useFormikContext } from "formik";
import {
  MdAttachMoney,
  MdMap,
  MdOutlineAddBusiness,
  MdSearch,
  MdSettings,
  MdSort,
} from "react-icons/md";
import { FaFileContract, FaMapMarkerAlt } from "react-icons/fa";
import BigSearcher from "./BigSearcher/BigSearcher";
import listingStyles from "../styles/listingsstyles.module.css";
import NumberFormat from "react-number-format";
import useWindowSize from "./Utility/windowSize";
import { BsFillLightningChargeFill, BsViewList } from "react-icons/bs";

import emptyState from "../public/images/search/emptyState.svg";
import errorState from "../public/images/search/errorState.svg";
import {
  checkRender,
  clusterStyles,
  options,
  StateSvg,
  ToolTipCreator,
  clientAnalytics,
  clientError,
} from "../utils/utilties";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import {
  BoldedSpan,
  MapToggleHolder,
  SmallFancyBold,
} from "../styles/ListingStyles";
import { AiFillSave } from "react-icons/ai";
import {
  Disclaimer,
  MyFormFakeLabel,
  MyFormLabel,
} from "../utils/clientUtilities";
import {
  BadgeFlex,
  InnerSearchWrapper,
  Searcher,
  SearchIcon,
  SearchText,
  SearchWrapper,
} from "./AppHeader/NewHeaderElements";
import * as Sentry from "@sentry/nextjs";
import {
  DeleteIcon,
  SmallCloseIcon,
  SmallAddIcon,
  ChevronDownIcon,
  RepeatClockIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ViewOffIcon,
  CheckCircleIcon,
  TriangleDownIcon,
  TriangleUpIcon,
  LockIcon,
} from "@chakra-ui/icons";
import { LabelAndTooltip } from "../styles/AddListingStyles";
import BottomLinks from "./Listings/BottomLinks/BottomLinks";
import SmallCount from "./Listings/SmallCount";
import dynamic from "next/dynamic";
import { QueryStateContext } from "../utils/contexts/QueryStateContext";

const GoogleMap = dynamic<GoogleMapProps>(() =>
  import("@react-google-maps/api").then((module) => module.GoogleMap)
);
const InfoWindow = dynamic<InfoWindowProps>(() =>
  import("@react-google-maps/api").then((module) => module.InfoWindow)
);
const Marker = dynamic<MarkerProps>(() =>
  import("@react-google-maps/api").then((module) => module.Marker)
);
const MarkerClusterer = dynamic<MarkerClustererProps>(() =>
  import("@react-google-maps/api").then((module) => module.MarkerClusterer)
);

// These are outside so react doesn't keep rerendering if these change
const libraries = ["places"];

const mapContainerStyle = {
  height: "100%",
  width: "100%",
};
const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};
const groupBadgeStyles = {
  backgroundColor: "#EBECF0",
  marginTop: "10px",
  borderRadius: "2em",
  color: "#172B4D",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.16666666666667em 0.5em",
  textAlign: "center",
};

const center = {
  lat: 52.130366,
  lng: -95.346771,
};

const Listings = ({
  query,
  staticData,
  staticType,
  subTypeGroup,
  businessTypeGroup,
  cleanedVariable,
  description,
  cleanedProvince,
  cleanedType,
  cleanedName,
  linkList1,
  linkList2,
  linkList1Header,
  linkList2Header,
  staticDesc,
  staticHeader,
  cityListingsByPropertyType,
  listingFooterText,
  province,
  city,
  businessCategoryValue,
  propertyTypeValue,
  subTypeValue,
  businessTypeValue,
}) => {
  const router = useRouter();
  const {
    queryState,
    setQueryState,
    showMap,
    setShowMap,
    expandedSubTypes,
    setExpandedSubTypes,
    propertyTypeChecked,
    setPropertyTypeChecked,
    subTypeChecked,
    setSubTypeChecked,
  } = useContext(QueryStateContext);
  // Filters
  const initialValues = {
    placeId: [],
    offMarket: [],
    brokerCoop: [],
    regions: [],
    propertyType: [],
    subType: [],
    type: [],
    cap: [],
    businessType: [],
    businessCategory: [],
    price: [],
    sqft: [],
    acres: [],
    keyword: [],
    timeline: [],
    sortBy: [],
    user: [],
    name: [],
    postedBy: [],
    page: [],
    bounds: [],
    province: [],
    city: [],
  };

  const [staticStatus, setStaticStatus] = useState(!!staticData);
  // Called when the form filters are applied. Updates filters in the queryState and the query params accordingly
  // use a QueryState interface for the param type
  const updateListingFilters = (updatedQueryState: typeof queryState) => {
    const { bounds, ...rest } = updatedQueryState;
    setQueryState(updatedQueryState);
    router.replace(
      {
        pathname: "/listings",
        query: { ...rest },
      },
      undefined,
      { shallow: true }
    );
  };

  async function fetchListingsRequest() {

    if (staticStatus) {
      const { coordinates } = staticData;

      setLocalCoordinates(coordinates);
      setRefreshCoordinates(true);
      return staticData;
    } else {
      const response = await fetch(
        `/api/listings?pub=true&refreshCoordinates=${
          showMap ? refreshCoordinates : false
        }`,
        {
          method: "GET",
          headers: {
            queries: JSON.stringify({...queryState, zoom}),
          },
        }
      );
      const data = await response.json();
      const { coordinates } = data;
      coordinates ? setLocalCoordinates(coordinates) : null;

      // Set refresh coordinates back to true
      setRefreshCoordinates(true);
      return data;
    }
  }
  const { data, status, error, refetch } = useQuery(
    ["listings", queryState, staticData, showMap],
    fetchListingsRequest,
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {},
    }
  );
  
  // use effect with data as the dependency
  useEffect(() => {
    if (data) {
      setCategorizedListings(categorizeListings(data));
    }
  }, [data]);
  // Update the categorization

// Function to categorize listings
function categorizeListings(data) {
  return data.listings?.reduce((result, listing) => {
    if (listing.priority == undefined || listing.priority < 2) {
      result.lowPriority.push(listing);
    } else {
      result.highPriority.push(listing);
    }
    return result;
  }, { highPriority: [], lowPriority: [] });
}
  const onAuthBoxClose = () => {
    setIsAuthBoxOpen(false);
  };

  const onSavedSearchClose = () => {
    setIsSavedSearchOpen(false);
  };
  const [minMaxState, setMinMaxState] = useState([0, 10000000]);
  const [infoId, setInfoId] = useState(null);
  let scroller = useRef(null);
  const [translatePixels, SetTranslatePixels] = useState(0);
  const [allowableScroll, setAllowableScroll] = useState(0);
  const size = useWindowSize();
  const [defaultIndexNum, setDefaultIndexNum] = useState([0]);
  const [actualFiltersCount, setActualFiltersCount] = useState(0);
  const [isAuthBoxOpen, setIsAuthBoxOpen] = useState(false);
  const [isSavedSearchOpen, setIsSavedSearchOpen] = useState(false);
  const [updateStatus, setUpdateStatus] = useState("idle");
  const [createStatus, setCreateStatus] = useState("idle");
  // const [optionsArray, setOptionsArray] = useState([])
  // const [receivedValue, setReceivedValue] = useState('')
  const [bigSearchBadges, setBigSearchBadges] = useState([]);
  const [unFormLowPrice, setunFormLowPrice] = useState(undefined);
  const [unFormHighPrice, setunFormHighPrice] = useState(undefined);
  const [unFormLowSize, setunFormLowSize] = useState(undefined);
  const [unFormHighSize, setunFormHighSize] = useState(undefined);
  const [unFormLowAcres, setunFormLowAcres] = useState(undefined);
  const [unFormHighAcres, setunFormHighAcres] = useState(undefined);
  const [tempTimeline, setTempTimeline] = useState(undefined);
  const [tempSortBy, setTempSortBy] = useState(undefined);
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  const [capLow, setCapLow] = useState(undefined);
  const [capHigh, setCapHigh] = useState(undefined);
  const [tempOffMarket, setTempOffMarket] = useState(false);
  const [tempPostedBy, setTempPostedBy] = useState(undefined);
  const [tempBrokerCoop, setTempBrokerCoop] = useState(false);
  const [savedSearchPending, setSavedSearchPending] = useState(false);
  const [unauthSavedSearchPending, setUnauthSavedSearchPending] =
    useState(false);
  const [savedSearchFiltersCount, setSavedSearchFiltersCount] = useState(0);
  const [categorizedListings, setCategorizedListings] = useState({ highPriority: [], lowPriority: [] })

  // const [regionGeometries, setRegionGeometries] = useState([]);

  const [authHeader, setAuthHeader] = useState(false);

  const user = useAuth()?.user;
  const userId = useAuth()?.userId;
  const profile = useAuth()?.profile;

  const toast = useToast();

  // If signed out user wanted to save search, do it as soon as they sign in
  useEffect(() => {
    if (profile && unauthSavedSearchPending) {
      savedSearchStarter();
    }
  }, [profile]);
  useEffect(() => {
    setAllowableScroll(size.width - 1421);
  }, [size]);

  useEffect(() => {
    // show map only on page sizes bigger than 768px
    const urlContainsCityOrProvince =
      province || city || query["province"] || query["city"];
    if (!showMap && size.width > 768 && urlContainsCityOrProvince) {
      setShowMap(true);
    } else if (showMap && size.width < 768) {
      setShowMap(false);
    }
  }, [size.width]);

  const regionGetter = async (placeId) => {
    // Badges
    let tempBadges = [];
    let tempBounds = [];

    // If Array
    if (Array.isArray(placeId)) {
      placeId.forEach(async (id) => {
        try {
          const results = await getGeocode({ placeId: id });
          const { formatted_address } = results[0];
          tempBadges.push({
            description: formatted_address.replace(", Canada", ""),
            place_id: id,
          });

          let boundObj = results[0]["geometry"]["bounds"]
            ? results[0]["geometry"]["bounds"]
            : results[0]["geometry"]["viewport"];

          let ne = boundObj.getNorthEast();
          let sw = boundObj.getSouthWest();
          tempBounds.push([sw.lng(), sw.lat(), ne.lng(), ne.lat()]);
          panTo(results[0]["geometry"]);
        } catch (e) {
          clientError(e);
        }
      });
    } else {
      const results = await getGeocode({ placeId });
      const { formatted_address } = results[0];
      tempBadges.push({
        description: formatted_address.replace(", Canada", ""),
        place_id: placeId,
      });
      let boundObj = results[0]["geometry"]["bounds"]
        ? results[0]["geometry"]["bounds"]
        : results[0]["geometry"]["viewport"];

      let ne = boundObj.getNorthEast();
      let sw = boundObj.getSouthWest();
      tempBounds.push([sw.lng(), sw.lat(), ne.lng(), ne.lat()]);
    }
    // Send bounds
    const { bounds, page, ...rest } = queryState;
    let newBoundObj = {
      // Put in the other keys
      ...queryState["bounds"],
      actualBounds: tempBounds,
      areaFilterTags: tempBadges,
    };
    setQueryState({
      ...rest,
      bounds: newBoundObj,
    });
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_MAPS_API_KEY,
    // @ts-ignore
    libraries,
  });

  useEffect(() => {
    // If there are any types or subtypes, add them to the checkbox state
    const {
      businessCategory,
      businessType,
      propertyType,
      subType,
      price,
      user,
      name,
      placeId,
      sqft,
      acres,
      offMarket,
      brokerCoop,
      cap,
      timeline,
      postedBy,
      sortBy,
    } = router.query;
    if (businessCategory?.length > 0) {
      let businessCategoryFilters = {};
      const businessCategoryArr = Array.isArray(businessCategory)
        ? [...businessCategory]
        : [businessCategory];
      businessCategoryArr.forEach((businessCategory) => {
        businessCategoryFilters[businessCategory] = true;
      });
      setBusinessCategoryChecked(businessCategoryFilters);
    }
    if (businessType?.length > 0) {
      let businessTypeFilters = {};
      const businessTypeArr = Array.isArray(businessType)
        ? [...businessType]
        : [businessType];
      businessTypeArr.forEach((businessType) => {
        AllBusiness.filter((i) => {
          if (i["value"] == businessType) {
            // setExpandedSubTypes({
            //   ...expandedSubTypes,
            //   [i['value']]: true
            // })
            businessTypeFilters[i["group"]]
              ? (businessTypeFilters[i["group"]] = [
                  ...businessTypeFilters[i["group"]],
                  i["value"],
                ])
              : (businessTypeFilters[i["group"]] = [i["value"]]);
          }
        });
      });

      setBusinessTypeChecked(businessTypeFilters);
    }

    if (propertyType?.length > 0) {
      let propertyTypeFilters = {};
      const propertyTypeArr = Array.isArray(propertyType)
        ? [...propertyType]
        : [propertyType];
      propertyTypeArr.forEach((type) => {
        propertyTypeFilters[type] = true;
      });
      setPropertyTypeChecked(propertyTypeFilters);
    }
    if (subType?.length > 0) {
      let subTypeFilters = {};
      const subTypeArr = Array.isArray(subType) ? [...subType] : [subType];
      subTypeArr.forEach((type) => {
        subTypeOptions.filter((i) => {
          if (i["value"] == type) {
            // setExpandedSubTypes({
            //   ...expandedSubTypes,
            //   [i['value']]: true
            // })
            subTypeFilters[i["group"]]
              ? (subTypeFilters[i["group"]] = [
                  ...subTypeFilters[i["group"]],
                  i["value"],
                ])
              : (subTypeFilters[i["group"]] = [i["value"]]);
          }
        });
      });

      setSubTypeChecked(subTypeFilters);
    }

    if (price?.length > 0 && Array.isArray(price)) {
      setunFormLowPrice(parseInt(price[0]));
      setunFormHighPrice(parseInt(price[1]));
    }

    if (cap?.length > 0 && Array.isArray(cap)) {
      setCapLow(parseInt(cap[0]));
      setCapHigh(parseInt(cap[1]));
    }

    if (sqft?.length > 0 && Array.isArray(sqft)) {
      setunFormLowSize(parseInt(sqft[0]));
      setunFormHighSize(parseInt(sqft[1]));
    }

    if (acres?.length > 0 && Array.isArray(acres)) {
      setunFormLowAcres(parseInt(acres[0]));
      setunFormHighAcres(parseInt(acres[1]));
    }

    if (offMarket) {
      setTempOffMarket(true);
      // Check if offMarket already in queryState
      if (!queryState["offMarket"] === true || !queryState["offMarket"] ) {
        updateListingFilters({
          ...queryState,
          offMarket: true,
        });
      }
    }

    if (postedBy) {
      if (!queryState["postedBy"] || queryState["postedBy"] !== postedBy) {
        updateListingFilters({
          ...queryState,
          postedBy,
        });
      }
    }

    if (user) {
      if (!queryState["user"] || queryState["user"] !== user) {
        updateListingFilters({
          ...queryState,
          user,
          name,
        });

      }
    }

    if (brokerCoop) {
      setTempBrokerCoop(true);
    }

    if (timeline) {
      setTempTimeline(timeline);
    }

    if (sortBy) {
      setTempSortBy(sortBy);
    }
  }, []);

  // Track on segment
  useEffect(() => {
    clientAnalytics.track("Listings page viewed");
  }, []);

  useEffect(() => {
    if (isLoaded && queryState.placeId.length > 0) {
      regionGetter(queryState.placeId);
    }
  }, [isLoaded]);

  const provinceSlugInRoute = provinceSlugs.find(
    (slug) => slug.slug == (router.query.id as string)
  );
  useEffect(() => {
    const { page, bounds, ...rest } = queryState;

    // Dont want to count user id filter in saved search counter
    const { user, ...rest2 } = rest;

    /*
      For routes that look like: /listings/<ProvinceSlug>, the staticType is set to "Province".
      In such a case that's a filter already, so set the filter count to an initial value of 1
    */

    let theCount = 0;
    if (!!provinceSlugInRoute) theCount += 1;

    Object.keys(rest).map((i) => {
      if (rest[i] == undefined || rest[i].length === 0 || i === 'name') {
        delete rest[i];
      }
    });

    theCount += Object.keys(rest).length;

    // For saved search
    let theCount2 = 0;

    Object.keys(rest2).map((i) => {
      if (rest2[i] == undefined || rest2[i].length === 0) {
        delete rest2[i];
      }
    });

    theCount2 = Object.keys(rest2).length;

    if (bounds?.actualBounds?.length > 0) {
      theCount2++;
    }
    setActualFiltersCount(theCount);
    setSavedSearchFiltersCount(theCount2);
    setSavedSearchCreated(false);

    savedSearchPending ? savedSearchStarter() : null;
  }, [queryState]);

  const triggerAuth = ({ hook, header, ...rest }) => {
    // Mixpanel.track(hook, { "Listing": id });

    clientAnalytics.track("Sign up attempted", {
      hook,
      ...rest,
    });

    setAuthHeader(header);
    setIsAuthBoxOpen(true);
  };

  const savedSearchStarter = () => {
    const { placeId, bounds, page, user, sortBy, timeline, ...rest } =
      queryState;
    let initialObj = { ...rest, uid: userId };
    if (bounds?.actualBounds?.length > 0) {
      let regions = queryState?.bounds?.areaFilterTags.filter(
        (badge) => badge["place_id"]
      );
      let regionsArray = [];
      regions.forEach((region, index) => {
        let regionObj = {};
        regionObj["description"] = region["description"];
        regionObj["bounds"] = bounds["actualBounds"][index];
        regionObj["place_id"] = region["place_id"];
        regionsArray.push(regionObj);
      });

      initialObj["regions"] = regionsArray;
    }

    let theCleaner = Object.keys(initialObj).forEach((obj) => {
      if (Array.isArray(initialObj[obj]) && initialObj[obj].length == 0) {
        delete initialObj[obj];
      }
    });

    // Clean out all the empty arrays in this

    savedSearchMutation.mutate(initialObj);
  };

  async function fechListingInfoRequest() {
    const response = await fetch(`/api/listings/${infoId}?type=brief`, {
      method: "GET",
      // headers: {
      //     type: "brief",
      // },
    });
    const data = await response.json();
    setSelectedUrlStatus("loading");
    return data;
  }

  const Clearer = () => {
    const { values, setFieldValue } = useFormikContext();
    const clear = () => {
      setTempKeyword("");
      // Object.keys(values).map((key) => {
      //   if (key !== "initialValues") {
      //     setFieldValue(key, []);
      //   }
      // });
      setQueryState(initialValues);
      setPropertyTypeChecked({});
      setSubTypeChecked({});
      setBusinessCategoryChecked({});
      setBusinessTypeChecked({});
      setExpandedSubTypes([]);
      setExpandedBusinessTypes([]);
      setunFormLowPrice(undefined);
      setunFormLowSize(undefined);
      setunFormHighSize(undefined);
      setunFormLowAcres(undefined);
      setunFormHighAcres(undefined);
      setunFormHighPrice(undefined);
      setCapLow(undefined);
      setCapHigh(undefined);
      setBigSearchBadges([]);
      setTempOffMarket(false);
      setTempBrokerCoop(false);
      router.replace(
        {
          pathname: "/listings",
          query: null,
        },
        undefined,
        { shallow: true }
      );
    };

    if (actualFiltersCount > 0 || staticStatus) {
      return (
        <Button
          mr="8px"
          onClick={() => {
            clear();
          }}
          _active={{ background: "myGray.300" }}
          _hover={{ background: "myGray.50" }}
          size="sm"
          leftIcon={<DeleteIcon />}
          colorScheme="black"
          variant="ghost"
        >
          Clear filters
        </Button>
      );
    } else return null;
  };

  const ApplyFilters = ({ type }) => {
    const apply = () => {
      let valuesObj = {};

      let propertyTypeArr = [];
      let businessCategoryArr = [];
      let subTypeArr = [];
      let businessTypeArr = [];

      let filteredBusinessCategories = Object.keys(
        businessCategoryChecked
      ).forEach((key) => {
        if (businessCategoryChecked[key]) {
          businessCategoryArr.push(key);
        }
      });
      let filteredBusinessTypes = Object.keys(businessTypeChecked).forEach(
        (key) => {
          if (businessTypeChecked[key]?.length > 0) {
            businessTypeArr = [...businessTypeArr, ...businessTypeChecked[key]];
          }
        }
      );

      let filteredTypes = Object.keys(propertyTypeChecked).forEach((key) => {
        if (propertyTypeChecked[key]) {
          propertyTypeArr.push(key);
        }
      });

      let filteredSubTypes = Object.keys(subTypeChecked).forEach((key) => {
        if (subTypeChecked[key]?.length > 0) {
          subTypeArr = [...subTypeArr, ...subTypeChecked[key]];
        }
      });

      valuesObj["propertyType"] = propertyTypeArr;
      valuesObj["subType"] = subTypeArr;
      valuesObj["businessType"] = businessTypeArr;
      valuesObj["businessCategory"] = businessCategoryArr;

      (unFormLowPrice && !isNaN(unFormLowPrice)) ||
      (unFormHighPrice && !isNaN(unFormHighPrice))
        ? (valuesObj["price"] = [
            !isNaN(unFormLowPrice) ? unFormLowPrice : 0,
            !isNaN(unFormHighPrice) ? unFormHighPrice : 1000000000,
          ])
        : (valuesObj["price"] = []);

      (unFormLowSize && !isNaN(unFormLowSize)) ||
      (unFormHighSize && !isNaN(unFormHighSize))
        ? (valuesObj["sqft"] = [
            !isNaN(unFormLowSize) ? unFormLowSize : 0,
            !isNaN(unFormHighSize) ? unFormHighSize : 1000000,
          ])
        : (valuesObj["sqft"] = []);
      (unFormLowAcres && !isNaN(unFormLowAcres)) ||
      (unFormHighAcres && !isNaN(unFormHighAcres))
        ? (valuesObj["acres"] = [
            !isNaN(unFormLowAcres) ? unFormLowAcres : 0,
            !isNaN(unFormHighAcres) ? unFormHighAcres : 1000000,
          ])
        : (valuesObj["acres"] = []);
      (capHigh && !isNaN(capHigh)) || (capLow && !isNaN(capLow))
        ? (valuesObj["cap"] = [
            !isNaN(capLow) ? capLow : 0,
            !isNaN(capHigh) ? capHigh : 100,
          ])
        : (valuesObj["cap"] = []);

      tempOffMarket
        ? (valuesObj["offMarket"] = true)
        : (valuesObj["offMarket"] = []);
      tempKeyword && tempKeyword.length > 0
        ? (valuesObj["keyword"] = tempKeyword)
        : (valuesObj["keyword"] = []);

      tempPostedBy && tempPostedBy.length > 0
        ? (valuesObj["postedBy"] = tempPostedBy)
        : (valuesObj["postedBy"] = []);
      tempBrokerCoop
        ? (valuesObj["brokerCoop"] = true)
        : (valuesObj["brokerCoop"] = []);
      valuesObj["timeline"] = tempTimeline ? tempTimeline : [];
      valuesObj["sortBy"] = tempSortBy ? tempSortBy : [];

      // setValues(valuesObj);
      updateListingFilters({
        ...queryState,
        ...valuesObj,
      });
      // onClose();
      onDrawerClose();

      if (type == "andSave") {
        let checkerSwitch = false;
        // Go through all values to check if there are missing ones
        let checker = Object.keys(valuesObj).forEach((i) => {
          if (valuesObj[i].length || typeof valuesObj[i] == "boolean") {
            checkerSwitch = true;
          }
        });
        // Check if there's anything to save
        if (checkerSwitch) {
          // Wait 5 seconds
          if (user) {
            setSavedSearchPending(true);
          } else {
            setUnauthSavedSearchPending(true);
            triggerAuth({
              hook: "Save search (Apply and Save button in filters)",
              header: "Log in or sign up to save this search",
            });
          }
        }
      }
    };

    if (type == "andSave") {
      return (
        <Button
          colorScheme="green"
          color="green.500"
          variant="outline"
          borderRadius="6px"
          leftIcon={<AiFillSave />}
          display={{ base: "none", sm: "flex" }}
          onClick={apply}
        >
          Apply and Save
        </Button>
      );
    } else if (type == "apply") {
      return (
        <Button colorScheme="green" borderRadius="6px" onClick={apply}>
          Apply
        </Button>
      );
    } else return null;
  };

  const SavetheSearch = () => {
    if (savedSearchFiltersCount > 0) {
      return (
        <Button
          onClick={() => {
            if (user) {
              savedSearchStarter();
            } else {
              setUnauthSavedSearchPending(true);
              triggerAuth({
                hook: "Save search",
                header: "Log in or sign up to save this search",
              });
            }
          }}
          paddingY="1rem"
          paddingX={{ base: "1rem", md: "1.75rem" }}
          size="sm"
          isLoading={createStatus == "loading"}
          loadingText="Saving..."
          leftIcon={<AiFillSave />}
          colorScheme="green"
          variant="solid"
          borderRadius="2rem"
          isDisabled={savedSearchCreated}
          boxShadow="0px 0px 4px rgba(0, 0, 0, 0.25)"
        >
          Save this search
        </Button>
      );
    } else return null;
  };

  const placeRemover = (index) => {
    // let placeIdsCopy = [...values['placeId']];
    let bigBadgesCopy = [...bigSearchBadges];
    let actualBoundsCopy = [...queryState["bounds"]["actualBounds"]];

    // placeIdsCopy.splice(index, 1)
    bigBadgesCopy.splice(index, 1);
    actualBoundsCopy.splice(index, 1);

    // setFieldValue('placeId', placeIdsCopy)
    setBigSearchBadges(bigBadgesCopy);

    const { bounds, page, ...rest } = queryState;

    if (staticStatus) {
      setStaticStatus(false);
      router.push({
        pathname: "/listings",
        query: {
          ...queryState,
          city: [],
          province: [],
        },
      });
      return;
    }

    // Remove actual bounds
    let newBoundObj = {
      // Put in the other keys
      ...queryState["bounds"],
      actualBounds: actualBoundsCopy,
    };
    setQueryState({
      bounds: newBoundObj,
      // page: [],
      ...rest,
    });
  };

  const FilterTag = ({ filter }) => {
    const filterValueHasRange =
      filter.name === "price" ||
      filter.name === "cap" ||
      filter.name === "sqft" ||
      filter.name === "acres";
    const removeFilter = () => {
      const _queryState = { ...queryState };
      let updatedFilters = _queryState[filter.name];
     
      if (Array.isArray(_queryState[filter.name])) {
        filter.name === "placeId"
          ? (updatedFilters = updatedFilters.filter(
              (value) => value !== filter.placeId
            ))
          : filterValueHasRange
          ? (updatedFilters = [])
          : (updatedFilters = updatedFilters.filter(
              (value) => value !== filter.value
            ));
      } else {
        updatedFilters = [];
      }

      _queryState[filter.name] = updatedFilters;
      if (filter.name === "user") {
         _queryState["name"] = []
      }

      let newBoundObj;
      if (filter.name === "placeId") {
        let areaFilterTagsCopy = [...queryState["bounds"]["areaFilterTags"]];
        let actualBoundsCopy = [...queryState["bounds"]["actualBounds"]];
        areaFilterTagsCopy.splice(filter.searchBadgeIndex, 1);
        actualBoundsCopy.splice(filter.searchBadgeIndex, 1);

        newBoundObj = {
          // Put in the other keys
          ..._queryState["bounds"],
          actualBounds: actualBoundsCopy,
          areaFilterTags: areaFilterTagsCopy,
        };
      }

      router.replace(
        {
          pathname: "/listings",
          query: _queryState,
        },
        undefined,
        {
          shallow: true,
        }
      );
      setQueryState({
        ..._queryState,
        bounds: !!newBoundObj ? newBoundObj : _queryState["bounds"],
        // page: [],
        // ...rest,
      });
    };

    const formatFilterValue = () => {
      const { name, value } = filter;
      if (!filterValueHasRange) {
        return value;
      }
      const fragments = value.split("-");

      const unitMap = {
        acre: "acres",
        cap: "cap",
        sqft: "sq. ft.",
        price: "",
      };
      const suffixMap = {
        cap: "%",
        price: "",
        sqft: "",
        acre: "",
      };
      const prefixMap = {
        price: "$",
        sqft: "",
        acre: "",
        cap: "",
      };

      return (
        <>
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={fragments[0]}
            prefix={prefixMap[name]}
            suffix={suffixMap[name]}
          />{" "}
          -{" "}
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={fragments[1]}
            prefix={prefixMap[name]}
            suffix={suffixMap[name]}
          />{" "}
          {unitMap[name]}
        </>
      );
    };

    return (
      <Tag size={"md"} borderRadius="5px" bgColor="#f8f8f8" p="8px 12px">
        <TagLabel color="#616161" fontSize={"16px"}>
          {formatFilterValue()}
        </TagLabel>
        <TagCloseButton
          onClick={removeFilter}
          color="#616161"
          _hover={{
            color: "#111",
            background: "#bbb",
          }}
        />
      </Tag>
    );
  };

  const FilterTags: any = ({ queryState }) => {
    const qs = queryState ?? {};

    const flattenedFilters = Object.keys(qs)
      .filter((key) => {
        if (key === "placeId") return false;
        if (key === 'name') return false;
        const value = qs[key];
        return Array.isArray(value) ? value.length : Boolean(value);
      })
      .reduce((acc, key) => {
        let filterQuery = qs[key];
        if (
          (key === "price" ||
            key === "cap" ||
            key === "sqft" ||
            key === "acres") &&
          Array.isArray(filterQuery)
        ) {
          filterQuery = queryState[key].join("-");
        }

        if (key === 'user') {
          filterQuery = [`Listings by ${router.query.name}`];
        }

        Array.isArray(filterQuery)
          ? filterQuery.forEach((value) => {
              acc.push({
                name: key,
                value,
              });
            })
          : acc.push({ name: key, value: filterQuery });
        return acc;
      }, []);
    return (
      <Flex gap="10px" flexWrap={"wrap"} mb="10px" px="10px" mr="10px">
        {flattenedFilters.map((filter, index) => {
          return <FilterTag key={index} filter={filter} />;
        })}
        {qs?.bounds?.areaFilterTags?.map((sb, index) => (
          <FilterTag
            key={sb["place_id"]}
            filter={{
              name: "placeId",
              value: sb["description"],
              searchBadgeIndex: index,
              placeId: sb["place_id"],
            }}
          />
        ))}
      </Flex>
    );
  };

  const FilterTagsMemoized = memo(FilterTags);

  const { data: infoData } = useQuery(
    ["infoCard", infoId],
    fechListingInfoRequest,
    {
      refetchOnWindowFocus: false,
      enabled: !!infoId,

      onSuccess: (data) => {
        setSelectedUrlStatus("success");
      },
    }
  );

  const [zoom, setZoom] = useState(4);
  // const [bounds, setBounds] = useState(null)
  // const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 })
  // const [address, setAddress] = useState("")
  // const [panDone, setPanDone] = useState(false);
  // const [boundsChanged, setBoundsChanged] = useState(false)
  const [localCoordinates, setLocalCoordinates] = useState(null);
  const [refreshCoordinates, setRefreshCoordinates] = useState(true);
  const [savedSearchCreated, setSavedSearchCreated] = useState(true);
  const [savedSearchData, setSavedSearchData] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const mapRef = useRef(null);
  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  
  const [selectedUrl, setSelectedUrl] = useState(placeholder);
  const [selectedUrlStatus, setSelectedUrlStatus] = useState("idle");
  const removeRestrictedArea = () => {
    setStaticStatus(false);
    if (staticType == "Province") {
      setQueryState({ ...queryState, province: [] });
    } else if (staticType?.includes("province&city")) {

      setQueryState({ ...queryState, province: [], city: [] });
    } else if (cleanedProvince) {

      setQueryState({ ...queryState, province: [] });
    }
  };

  const actualBoundUpdater = (boundsreceived, setBySystem = false) => {
    if (boundsreceived) {
      staticStatus && !setBySystem && setStaticStatus(false);
      const { ne, sw } = boundsreceived;

      const { bounds, page, ...rest } = queryState;
      setRefreshCoordinates(true);

      if (queryState.bounds?.actualBounds?.length > 0) {
        let newBoundObj = {
          // Put in the other keys
          ...queryState["bounds"],
          actualBounds: [
            ...queryState.bounds?.actualBounds,
            [sw.lng(), sw.lat(), ne.lng(), ne.lat()],
          ],
        };
        setQueryState({
          bounds: newBoundObj,
          // page: [],
          ...rest,
        });
      } else {
        let newBoundObj = {
          // Put in the other keys
          ...queryState["bounds"],
          actualBounds: [[sw.lng(), sw.lat(), ne.lng(), ne.lat()]],
        };

        setQueryState({
          bounds: newBoundObj,
          // page: [],
          ...rest,
        });
      }
    }
  };

  const mapBoundUpdater = () => {

    let ne = mapRef.current?.getBounds()?.getNorthEast();
    let sw = mapRef.current?.getBounds()?.getSouthWest();
    
    if (ne && sw) {
      const { bounds, page, ...rest } = queryState;
      setRefreshCoordinates(false);
      setQueryState({
        bounds: {
          // Put in the other keys
          ...queryState["bounds"],
          mapBounds: [sw.lng(), sw.lat(), ne.lng(), ne.lat()],
        },
        // page: [],
        ...rest,
      });
    }
  };

  let MapJSX;
  if (loadError) MapJSX = "Error loading maps";
  if (!isLoaded) MapJSX = "Loading Maps";
  else if (showMap) {
    MapJSX = (
      <GoogleMap
        onClick={() => {
          setInfoId(null);
        }}
        
    
        // latlng
        mapContainerStyle={mapContainerStyle}
        zoom={4}
        // If user drags or zooms in/out of the map - remove the name of the area if it's there
        options={options}
        center={center}
        onLoad={onMapLoad}
        onDragEnd={() => {
          // setBoundsChanged(true)

          clientAnalytics.track("Map dragged");
          mapBoundUpdater();
        }}
        onZoomChanged={() => {
          mapRef.current ? setZoom(mapRef?.current?.zoom) : null;
          mapBoundUpdater();
        }}
      >
         
        {/* {(staticType == 'Province' || (staticType == 'province&subType' && cleanedProvince)) && staticStatus &&
                <KmlLayer
            url={`https://feature-zonado.vercel.app/kml/${provinceShorter(staticType == 'Province' ? cleanedVariable : cleanedProvince).toLowerCase()}.kml`} />
            } */}

        {(staticType?.includes("rovince") || cleanedProvince) &&
          data?.listings &&
          staticStatus && (
            <RemoveBoundaryHolder>
              <RemoveBoundaryInner>
                <Flex alignItems="center">
                  {data?.countOfListings}{" "}
                  {data?.countOfListings > 1 || data?.countOfListings < 1
                    ? `results`
                    : `result`}
                  <Button
                    fontSize="15px"
                    ml="5px"
                    colorScheme="green"
                    variant="link"
                    onClick={() => {
                      removeRestrictedArea();
                    }}
                  >
                    Remove Boundary
                  </Button>
                </Flex>
              </RemoveBoundaryInner>
            </RemoveBoundaryHolder>
          )}

        {localCoordinates && (
          <MarkerClusterer
            styles={clusterStyles}
            averageCenter
            enableRetinaIcons
            gridSize={60}
          >
            {(clusterer) =>
              localCoordinates.map((obj) => {
                return (
                  <Marker
                    position={obj.coordinates}
                    key={obj.id}
                    // onMouseOver={()=> {

                    //     obj.id !== infoId ? setInfoId(obj.id) : null
                    // }}
                    onClick={() => {
                      clientAnalytics.track("Map marker clicked", {
                        infoId: obj.id,
                      });
                      setInfoId(obj.id);
                    }}
                    clusterer={clusterer}
                    icon={{
                      url: "/images/marker.svg",
                    }}
                  />
                );
              })
            }
          </MarkerClusterer>
        )}

        {/* Check that a selected id currently exists and matches the one that's been loaded */}
        {infoId && infoData?.id === infoId && (
          <InfoWindow
            position={infoData.coordinates}
            onCloseClick={() => {
              setInfoId(null);
            }}
          >
            <Box width="220px" marginBottom="0px" pointerEvents="none">
              <Box
                backgroundColor="white"
                color="#222"
                pointerEvents="auto"
                position="relative"
                width="100%"
              >
                <Link
                  prefetch={false}
                  href={`/listings/${encodeURIComponent(infoId)}/${slugify(
                    infoData.subject
                  )}`}
                  target="_blank"
                  style={{
                    inset: "0px",
                    position: "absolute",
                  }}>

                </Link>

                {/* Image Box */}

                {selectedUrlStatus === "success" && (
                  <Box
                    pointerEvents="none"
                    width="100%"
                    height="auto"
                    objectFit="cover"
                    color="white"
                    mb="8px"
                  >
                    {/* ? */}
                    <NextImage
                      src={infoData?.imageURLs[0]}
                      width={165}
                      height={100}
                      sizes="100vw"
                      style={{
                        width: "100%",
                        height: "auto"
                      }} />
                    {/* :
                                            <Skeleton height="165px" /> */}
                  </Box>
                )}

                {/* Text Box */}
                <Box
                  // padding="16px"
                  fontSize="14px"
                  fontFamily="'Jarkarta', sans-serif"
                >
                  {/* Text box 1 */}
                  <Text
                    marginBottom="5px"
                    maxH="20px"
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    {infoData.propertyTypes.join(", ")} &bull; {infoData.city}
                  </Text>

                  {/* Text box 1 */}
                  <Text
                    marginBottom="5px"
                    maxH="20px"
                    overflow="hidden"
                    fontSize="16px"
                    fontWeight={300}
                    textOverflow="ellipsis"
                  >
                    <NumberFormat
                      value={infoData.price}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                      suffix={
                        infoData.type === "For Lease"
                          ? `/${infoData.priceType}`
                          : null
                      }
                    />
                  </Text>

                  {/* Text box 1 */}
                  <Text
                    marginBottom="0px"
                    // maxH="33px"
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    {infoData.subject}
                  </Text>
                  <Link
                    prefetch={false}
                    href={`/listings/${encodeURIComponent(infoId)}/${slugify(
                      infoData.subject
                    )}`}
                    target="_blank"
                  >

                    <Button
                      size="sm"
                      display="block"
                      my="8px"
                      mx="auto"
                      variant="link"
                      colorScheme="green"
                    >
                      View Details
                    </Button>

                  </Link>
                </Box>
              </Box>
            </Box>
          </InfoWindow>
        )}
      </GoogleMap>
    );
  }

  const [tempPrice, setTempPrice] = useState(
    query?.price?.length === 2 && Array.isArray(query?.price)
      ? [parseInt(query["price"][0]), parseInt(query["price"][1])]
      : [0, 10000000]
  );
  const [tempKeyword, setTempKeyword] = useState(
    query?.keyword?.length > 0 ? query?.keyword : ""
  );

  const SmartCheckboxGroup = ({ label, options, ...props }) => {
    // @ts-ignore
    const [field, meta, helper] = useField(props);
    const { name } = field;
    const { values, setFieldValue } = useFormikContext();

    return (
      <CheckboxGroup
        isDisabled={props.isDisabled}
        {...field}
        {...props}
        onChange={(value) => {
          setFieldValue(name, value);
        }}
        // id={name}
        // spacing={"14px"}
        value={values[name]}
        colorScheme="green"
      >
        <Stack>
          {options.map((type, index) => (
            <Checkbox
              defaultChecked={
                queryState[name] &&
                (queryState[name] == type["value"] ||
                  queryState[name].includes(type["value"]))
              }
              key={index}
              value={type["value"]}
            >
              {type["label"]}
            </Checkbox>
          ))}
        </Stack>
      </CheckboxGroup>
    );
  };

  const onDrawerClose = () => {
    setIsFilterDrawerOpen(false);
  };

  const onDrawerOpen = () => {
    setIsFilterDrawerOpen(true);
  };

  const ApplyTypes = () => {
    const { values, setFieldValue } = useFormikContext();

    let propertyType = [];
    let subType = [];

    let filteredTypes = Object.keys(propertyTypeChecked).forEach((key) => {
      if (propertyTypeChecked[key]) {
        propertyType.push(key);
      }
    });

    let filteredSubTypes = Object.keys(subTypeChecked).forEach((key) => {
      if (subTypeChecked[key]?.length > 0) {
        subType.push(key);
      }
    });

    setFieldValue("propertyType", propertyType);
    setFieldValue("subType", subType);
  };

  const PropertyTypeFilterCheckboxes = () => {
    return (
      <Stack spacing={2}>
        {propertyTypeOptions.map((thisType, thisIndex) => (
          <Box key={thisIndex}>
            <Flex justifyContent={"space-between"} w="100%">
              <Checkbox
                colorScheme="green"
                isChecked={propertyTypeChecked[thisType["value"]]}
                isIndeterminate={
                  subTypeChecked[thisType["value"]] &&
                  Array.isArray(subTypeChecked[thisType["value"]]) &&
                  subTypeChecked[thisType["value"]].some(Boolean) &&
                  !propertyTypeChecked[thisType["value"]]
                }
                onChange={(e) => {
                  let typeCheckedCopy = { ...propertyTypeChecked };

                  typeCheckedCopy[thisType["value"]] = e.target.checked;
                  setPropertyTypeChecked({ ...typeCheckedCopy });

                  // Remove subtypes for this property type from the selection
                  // IE - if all of land is selected, we don't need the subtypes (redundant)
                  // If all of land is unselected, then we definitely don't need the subtypes (not the criteria)
                  let subTypeCopy = { ...subTypeChecked };
                  subTypeCopy[thisType["value"]] = [];
                  setSubTypeChecked({ ...subTypeCopy });

                  // Expand children
                  if (e.target.checked) {
                    let expandedSubTypesCopy = { ...expandedSubTypes };

                    expandedSubTypesCopy[thisType["value"]] = true;
                    setExpandedSubTypes({ ...expandedSubTypesCopy });
                  }
                }}
                children={thisType["value"]}
              />

              {groupedSubtype[thisIndex]["options"]?.length > 0 &&
                groupedSubtype[thisIndex]["label"].toLowerCase() !==
                  "sale of business" && (
                  <IconButton
                    aria-label="expand"
                    variant="ghost"
                    size="sm"
                    icon={
                      expandedSubTypes[thisType["value"]] ? (
                        <SmallCloseIcon />
                      ) : (
                        <SmallAddIcon />
                      )
                    }
                    onClick={() => {
                      let expandedSubTypesCopy = { ...expandedSubTypes };

                      if (expandedSubTypes[thisType["value"]]) {
                        expandedSubTypesCopy[thisType["value"]] = false;
                        setExpandedSubTypes({ ...expandedSubTypesCopy });
                      } else {
                        expandedSubTypesCopy[thisType["value"]] = true;
                        setExpandedSubTypes({ ...expandedSubTypesCopy });
                      }
                    }}
                  />
                )}
            </Flex>
            {/* To avoid mixed use */}
            {groupedSubtype[thisIndex]["options"]?.length > 0 &&
              groupedSubtype[thisIndex]["label"].toLowerCase() !==
                "sale of business" && (
                <Collapse
                  // mt={4}
                  in={expandedSubTypes[thisType["value"]]}
                >
                  <Stack pl={6} mt={1} spacing={2}>
                    {groupedSubtype[thisIndex]["options"].map((opt, index) => (
                      <Checkbox
                        key={index}
                        colorScheme="green"
                        isChecked={
                          propertyTypeChecked[thisType["value"]] ||
                          subTypeChecked[thisType["value"]]?.includes(
                            opt["value"]
                          )
                        }
                        onChange={(e) => {
                          let subTypeCopy = { ...subTypeChecked };
                          if (e.target.checked) {
                            // Does this already exist in the objects? If so then add to it, if not then save it
                            if (subTypeCopy[thisType["value"]]) {
                              let thisSubTypeCopy =
                                subTypeCopy[thisType["value"]];
                              subTypeCopy[thisType["value"]] = [
                                ...thisSubTypeCopy,
                                opt["value"],
                              ];
                              setSubTypeChecked({ ...subTypeCopy });

                              // If all are checked for this subtype, make the type true overall
                              if (
                                subTypeCopy[thisType["value"]].length ==
                                  groupedSubtype[thisIndex]["options"].length &&
                                subTypeCopy[thisType["value"]].every(Boolean)
                              ) {
                                let typeCheckedCopy = {
                                  ...propertyTypeChecked,
                                };

                                typeCheckedCopy[thisType["value"]] = true;

                                setPropertyTypeChecked({ ...typeCheckedCopy });

                                // And remove the subyptes for this type
                                // If all of land is unselected, then we definitely don't need the subtypes (not the criteria)
                                subTypeCopy[thisType["value"]] = [];
                                setSubTypeChecked({ ...subTypeCopy });
                              }
                            } else {
                              subTypeCopy[thisType["value"]] = [opt["value"]];
                              setSubTypeChecked({ ...subTypeCopy });
                            }
                          } else {
                            const index = subTypeCopy[
                              thisType["value"]
                            ].indexOf(opt["value"]);
                            // Check if it exists
                            if (index > -1) {
                              subTypeCopy[thisType["value"]].splice(index, 1);
                              setSubTypeChecked({ ...subTypeCopy });

                              // If office checked is true, make it false
                              if (propertyTypeChecked[thisType["value"]]) {
                                let typeCheckedCopy = {
                                  ...propertyTypeChecked,
                                };
                                typeCheckedCopy[thisType["value"]] = false;
                                setPropertyTypeChecked({ ...typeCheckedCopy });
                              }
                            }

                            // The event when this subtype wasn't explicity selected but was showing up as such because the overall type was selected, remove this type from typeselected, and add all other subtypes to the selection but this particular one (since it is being removed)
                            else if (propertyTypeChecked[thisType["value"]]) {
                              // Remove this from typechecked
                              let typeCheckedCopy = { ...propertyTypeChecked };
                              typeCheckedCopy[thisType["value"]] = false;
                              setPropertyTypeChecked({ ...typeCheckedCopy });

                              // Add all subtypes but this one
                              let listOfAllOthers = [];

                              groupedSubtype[thisIndex]["options"].forEach(
                                (o) => {
                                  if (o["value"] != opt["value"]) {
                                    listOfAllOthers.push(o["value"]);
                                  }
                                }
                              );

                              subTypeCopy[thisType["value"]] = listOfAllOthers;
                              setSubTypeChecked({ ...subTypeCopy });
                            }
                          }
                        }}
                        children={opt["value"]}
                      />
                    ))}
                    {/* <Checkbox
                              isChecked={subTypeChecked[1]}
                              onChange={e => setSubTypeChecked([subTypeChecked[0], e.target.checked])}
                              children="Child Checkbox 2"
                              /> */}
                  </Stack>
                </Collapse>
              )}
          </Box>
        ))}
      </Stack>
    );
  };
  const BusinessFilterCheckboxes = () => {
    return (
      <Stack spacing={2}>
        {groupedBusiness.map((thisType, thisIndex) => (
          <Box key={thisIndex}>
            <Flex justifyContent={"space-between"} w="100%">
              <Checkbox
                colorScheme="green"
                isChecked={businessCategoryChecked[thisType["value"]]}
                isIndeterminate={
                  businessTypeChecked[thisType["value"]] &&
                  Array.isArray(businessTypeChecked[thisType["value"]]) &&
                  businessTypeChecked[thisType["value"]].some(Boolean) &&
                  !businessCategoryChecked[thisType["value"]]
                }
                onChange={(e) => {
                  let businessCategoryCheckedCopy = {
                    ...businessCategoryChecked,
                  };

                  businessCategoryCheckedCopy[thisType["value"]] =
                    e.target.checked;
                  setBusinessCategoryChecked({
                    ...businessCategoryCheckedCopy,
                  });

                  // Remove subtypes for this property type from the selection
                  // IE - if all of land is selected, we don't need the subtypes (redundant)
                  // If all of land is unselected, then we definitely don't need the subtypes (not the criteria)
                  let businessTypeCopy = { ...businessTypeChecked };
                  businessTypeCopy[thisType["value"]] = [];
                  setBusinessTypeChecked({ ...businessTypeCopy });

                  // Expand children
                  if (e.target.checked) {
                    let expandedBuinessTypesCopy = { ...expandedBusinessTypes };

                    expandedBuinessTypesCopy[thisType["value"]] = true;
                    setExpandedBusinessTypes({ ...expandedBuinessTypesCopy });
                  }
                }}
                children={thisType["value"]}
              />

              {thisType["options"]?.length > 0 && (
                <IconButton
                  aria-label="expand"
                  variant="ghost"
                  size="sm"
                  icon={
                    expandedBusinessTypes[thisType["value"]] ? (
                      <SmallCloseIcon />
                    ) : (
                      <SmallAddIcon />
                    )
                  }
                  onClick={() => {
                    let expandedBusinessTypesCopy = {
                      ...expandedBusinessTypes,
                    };

                    if (expandedBusinessTypes[thisType["value"]]) {
                      expandedBusinessTypesCopy[thisType["value"]] = false;
                      setExpandedBusinessTypes({
                        ...expandedBusinessTypesCopy,
                      });
                    } else {
                      expandedBusinessTypesCopy[thisType["value"]] = true;
                      setExpandedBusinessTypes({
                        ...expandedBusinessTypesCopy,
                      });
                    }
                  }}
                />
              )}
            </Flex>
            {/* To avoid mixed use */}
            {thisType["options"]?.length > 0 && (
              <Collapse
                // mt={4}
                in={expandedBusinessTypes[thisType["value"]]}
              >
                <Stack pl={6} mt={1} spacing={2}>
                  {thisType["options"].map((opt, index) => (
                    <Checkbox
                      key={index}
                      colorScheme="green"
                      isChecked={
                        businessCategoryChecked[thisType["value"]] ||
                        businessTypeChecked[thisType["value"]]?.includes(
                          opt["value"]
                        )
                      }
                      onChange={(e) => {
                        let businessTypeCopy = { ...businessTypeChecked };
                        if (e.target.checked) {
                          // Does this already exist in the objects? If so then add to it, if not then save it
                          if (businessTypeCopy[thisType["value"]]) {
                            let thisBusinessTypeCopy =
                              businessTypeCopy[thisType["value"]];
                            businessTypeCopy[thisType["value"]] = [
                              ...thisBusinessTypeCopy,
                              opt["value"],
                            ];
                            setBusinessTypeChecked({ ...businessTypeCopy });

                            // If all are checked for this subtype, make the type true overall
                            if (
                              businessTypeCopy[thisType["value"]].length ==
                                thisType["options"].length &&
                              businessTypeCopy[thisType["value"]].every(Boolean)
                            ) {
                              let businessCategoryCheckedCopy = {
                                ...businessCategoryChecked,
                              };

                              businessCategoryCheckedCopy[thisType["value"]] =
                                true;

                              setBusinessCategoryChecked({
                                ...businessCategoryCheckedCopy,
                              });

                              // And remove the subyptes for this type
                              // If all of land is unselected, then we definitely don't need the subtypes (not the criteria)
                              businessTypeCopy[thisType["value"]] = [];
                              setBusinessTypeChecked({ ...businessTypeCopy });
                            }
                          } else {
                            businessTypeCopy[thisType["value"]] = [
                              opt["value"],
                            ];
                            setBusinessTypeChecked({ ...businessTypeCopy });
                          }
                        } else {
                          const index = businessTypeCopy[
                            thisType["value"]
                          ].indexOf(opt["value"]);
                          // Check if it exists
                          if (index > -1) {
                            businessTypeCopy[thisType["value"]].splice(
                              index,
                              1
                            );
                            setBusinessTypeChecked({ ...businessTypeCopy });

                            // If office checked is true, make it false
                            if (businessCategoryChecked[thisType["value"]]) {
                              let businessCategoryCopy = {
                                ...businessCategoryChecked,
                              };
                              businessCategoryCopy[thisType["value"]] = false;
                              setBusinessCategoryChecked({
                                ...businessCategoryCopy,
                              });
                            }
                          }

                          // The event when this subtype wasn't explicity selected but was showing up as such because the overall type was selected, remove this type from typeselected, and add all other subtypes to the selection but this particular one (since it is being removed)
                          else if (businessCategoryChecked[thisType["value"]]) {
                            // Remove this from typechecked
                            let businessCategoryCheckedCopy = {
                              ...businessCategoryChecked,
                            };
                            businessCategoryCheckedCopy[thisType["value"]] =
                              false;
                            setBusinessCategoryChecked({
                              ...businessCategoryCheckedCopy,
                            });

                            // Add all subtypes but this one
                            let listOfAllOthers = [];

                            thisType["options"].forEach((o) => {
                              if (o["value"] != opt["value"]) {
                                listOfAllOthers.push(o["value"]);
                              }
                            });

                            businessTypeCopy[thisType["value"]] =
                              listOfAllOthers;
                            setBusinessTypeChecked({ ...businessTypeCopy });
                          }
                        }
                      }}
                      children={opt["value"]}
                    />
                  ))}
                  {/* <Checkbox
                            isChecked={subTypeChecked[1]}
                            onChange={e => setSubTypeChecked([subTypeChecked[0], e.target.checked])}
                            children="Child Checkbox 2"
                            /> */}
                </Stack>
              </Collapse>
            )}
          </Box>
        ))}
      </Stack>
    );
  };

  const SmartRadioGroup = ({ label, options, ...props }) => {
    // @ts-ignore
    const [field, meta, helper] = useField(props);
    const { name } = field;
    // const { values, setFieldValue } = useFormikContext();

    return (
      <RadioGroup
        {...field}
        isDisabled={props.isDisabled}
        {...props}
        onChange={(val) => {
          updateListingFilters({
            ...queryState,
            [name]: val,
          });
          // setFieldValue(name, val);
        }}
        id={name}
        // value={values[name] ? values[name] : initialValues[name]}
        value={queryState[name]}
      >
        <Stack>
          {options.map((type, index) => (
            <Radio
              defaultChecked={
                queryState[name] && queryState[name] == type["value"]
              }
              key={index}
              colorScheme="green"
              value={type["value"]}
            >
              {type["label"]}
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
    );
  };

  const panTo = useCallback((obj) => {
    // !showMap ? setShowMap(true) : null
    // mapRef?.current?.panTo({ lat, lng });
    //
    // mapRef?.current?.setZoom(6);
    // // mapBoundUpdater()
    // setCoordinates({ lng: lng, lat: lat })

    // let regionGeometriesCopy = [...regionGeometries, obj]

    // // New code
    //
    // const bounds = mapRef?.current.LatLngBounds();

    // regionGeometriesCopy.forEach(geometry => {
    //     if (geometry.viewport) {
    //         bounds.union(geometry.viewport)
    //     } else {
    //         bounds.extend(geometry.location)
    //     }
    // });
    // setRegionGeometries(regionGeometriesCopy);
    // setStaticStatus(false);
    // panDone ? null : setPanDone(true)
    mapRef.current?.fitBounds(obj["bounds"]);
  }, []);

  async function createSavedSearchRequest(saveData) {
    setCreateStatus("loading");
    const response = await fetch("/api/savedSearch/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
        userId: userId,
      },
      body: JSON.stringify({ data: saveData }),
    });

    const data = await response.json();
    const { save } = data;

    return save;
  }

  const savedSearchMutation = useMutation(createSavedSearchRequest, {
    onError: (error) => {
      clientError(error);
    },

    onSuccess: (ssData) => {
      if (!ssData) {
        toast({
          position: "bottom",
          title: "Oops! We couldn't save that",
          description:
            "We're looking into what went wrong. Please try again later.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        throw "Error saving search";
      } else {
        setSavedSearchCreated(true);
        setIsSavedSearchOpen(true);
        setSavedSearchData(ssData);

        // toast({
        //     position: "bottom",
        //     title: "Listing saved",
        //     description: "It is now visible in your saved listings on the left panel",
        //     status: "success",
        //     variant: "subtle",
        //     duration: 3000,
        //     isClosable: true,
        // })
      }
    },
    onSettled: () => {
      setCreateStatus("idle");
      setSavedSearchPending(false);
      setUnauthSavedSearchPending(false);
    },
  });

  const updateSavedSearchReq = async (passedData) => {
    setUpdateStatus("loading");
    // setDeleteProcessLoading(true);
    const response = await fetch(
      `/api/savedSearch/${savedSearchData["id"]}/update`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: await getToken(),
        },
        body: JSON.stringify({ updatedData: passedData }),
      }
    );

    const data = await response.json();
    const { savedSearches } = data;

    return savedSearches;
  };

  const savedSearchUpdate = useMutation(updateSavedSearchReq, {
    onError: (error) => {
      setUpdateStatus("idle");
      toast({
        title: "Error",
        variant: "subtle",
        description: `An error occured. Please try again later.`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      clientError(error);
    },

    onSuccess: (theData) => {
      if (theData) {
        setUpdateStatus("idle");
        setIsSavedSearchOpen(false);

        toast({
          title: "Updated",
          description: "Updated saved search successfully.",
          variant: "subtle",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      } else throw "error";
    },
  });

  // For Slider
  const STEP = minMaxState[1] / 1000;
  const MIN = minMaxState[0];
  // data?.['minPrice'] ? data['minPrice'] :
  // 0;
  const MAX = minMaxState[1];
  // data?.['maxPrice'] ? data['maxPrice'] :
  // 20000000;
  const [businessCategoryChecked, setBusinessCategoryChecked] = useState({});
  const [businessTypeChecked, setBusinessTypeChecked] = useState({});
  const [expandedBusinessTypes, setExpandedBusinessTypes] = useState({});

  useEffect(() => {
    if (staticStatus) {
      if (propertyTypeValue) {
        setPropertyTypeChecked({
          ...propertyTypeChecked,
          [propertyTypeValue]: true,
        });
      } else if (subTypeGroup && subTypeValue) {
        setSubTypeChecked({
          ...subTypeChecked,
          [subTypeGroup]: [subTypeValue],
        });
        setExpandedSubTypes({
          ...expandedSubTypes,
          [subTypeGroup]: true,
        });
      } else if (businessCategoryValue) {
        setBusinessCategoryChecked({
          ...businessCategoryChecked,
          [businessCategoryValue]: true,
        });
      } else if (businessTypeValue) {
        setBusinessTypeChecked({
          ...businessTypeChecked,
          [businessTypeGroup]: [businessTypeValue],
        });
        setExpandedBusinessTypes({
          ...expandedBusinessTypes,
          [businessTypeGroup]: true,
        });
      }
    }
  }, []);

  useEffect(() => {
    if (queryState.propertyType) {
      if (!queryState.propertyType.length) {
        setPropertyTypeChecked({});
        return;
      }
      const result = queryState.propertyType.reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {});
      setPropertyTypeChecked({
        ...result,
      });
    }
  }, [queryState.propertyType]);
  useEffect(() => {
    if (queryState.subType) {
      if (!queryState.subType.length) return setSubTypeChecked({});
      const result = queryState.subType.reduce((acc, curr) => {
        const subTypeObj = subTypeOptions.find(
          (subType) => subType.value === curr
        );
        if (subTypeObj) {
          const subTypeGroup = subTypeObj.group;
          if (Object.keys(acc).includes(subTypeGroup)) {
            acc[subTypeObj.group].push(curr);
          } else {
            acc[subTypeObj.group] = [curr];
          }
        }
        return acc;
      }, {});
      setSubTypeChecked(result);
    }
  }, [queryState.subType]);
  useEffect(() => {
    if (queryState.businessCategory) {
      if (!queryState.businessCategory.length)
        return setBusinessCategoryChecked({});
      const result = queryState.businessCategory.reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {});
      setBusinessCategoryChecked(result);
    }
  }, [queryState.businessCategory]);
  useEffect(() => {
    if (queryState.businessType) {
      if (!queryState.businessType.length) return setBusinessTypeChecked({});
      const result = queryState.businessType.reduce((acc, curr) => {
        const businessTypeObj = AllBusiness.find(
          (businessType) => businessType.value === curr
        );
        if (businessTypeObj) {
          const businessTypeGroup = businessTypeObj.group;
          if (Object.keys(acc).includes(businessTypeGroup)) {
            acc[businessTypeObj.group].push(curr);
          } else {
            acc[businessTypeObj.group] = [curr];
          }
        }
        return acc;
      }, {});
      setBusinessTypeChecked(result);
    }
  }, [queryState.businessType]);

  // const officeChecked = subTypeChecked.every(Boolean);
  // const isIndeterminate = subTypeChecked.some(Boolean) && !propertyTypeChecked[propertyTypeOptions[0]['value']];
  return (<>
    <SideNav />
    <MainHolder>
      <StaticHolder>
        <FixedSearcherHolder pro={profile?.pro}>
          <FixedSearcherMaxW>
            <BigSearcher panTo={panTo} />
          </FixedSearcherMaxW>
        </FixedSearcherHolder>
        <Formik initialValues={queryState} onSubmit={() => {}}>
          {({
            isSubmitting,
            isValid,
            handleChange,
            values,
            handleSubmit,
            errors,
            touched,
            setFieldValue,
          }) => (
            <>
              <Drawer
                onClose={onDrawerClose}
                isOpen={isFilterDrawerOpen}
                size={"xl"}
                placement="left"
              >
                <DrawerOverlay />
                <DrawerContent zIndex={21474836470}>
                  <DrawerCloseButton />
                  <DrawerHeader
                    fontWeight="500"
                    fontFamily="'Jarkarta', sans-serif"
                  >
                    All filters{" "}
                  </DrawerHeader>
                  <DrawerBody>
                    <Grid
                      gridTemplateColumns={{ base: "1fr", lg: "1fr 1fr" }}
                      gridColumnGap="24px"
                      gridRowGap="36px"
                    >
                      <Grid gridRowGap="32px" gridAutoRows="max-content">
                        <Box>
                          <FilterHeader>Keyword</FilterHeader>
                          <Field name="keyword">
                            {({ field, form }) => (
                              <InputGroup size="md">
                                {/* <Tooltip label="Search for type of property, listing #, location, user, brokerage, or anything else mentioned in the listing." placement="bottom"> */}
                                {/* <> */}
                                <Input
                                  height="2.25rem"
                                  fontSize="0.875rem"
                                  data-hj-allow
                                  size="sm"
                                  {...field}
                                  id="keyword"
                                  borderColor={
                                    queryState?.keyword?.length > 0
                                      ? "brand.900"
                                      : "myGray.100"
                                  }
                                  value={tempKeyword}
                                  onChange={(e) => {
                                    setTempKeyword(e.target.value);
                                  }}
                                  // Submit if the person hit Enter
                                  // onKeyDown={(e) => {
                                  //     if (e.key === 'Enter') {
                                  //         e.target.value.length > 0 ? setFieldValue('keyword', e.target.value) : setFieldValue('keyword', [])
                                  //     }
                                  // }}
                                  pr="2.25rem"
                                  placeholder="Keyword"
                                  _focus={{
                                    borderColor: "#125f3f",
                                    boxShadow: "0 0 0 1px #125f3f",
                                  }}
                                />
                                {/* </> */}
                                {/* </Tooltip> */}
                              </InputGroup>
                            )}
                          </Field>
                        </Box>

                        <Box>
                          <FilterHeader>Type</FilterHeader>
                          <SmartRadioGroup
                            name="type"
                            options={transactionTypeOptions}
                            label={undefined}
                          />
                        </Box>
                        <Box>
                          <FilterHeader>Property type(s)</FilterHeader>
                          <PropertyTypeFilterCheckboxes />
                        </Box>

                        <Box>
                          <FilterHeader>Businesses</FilterHeader>
                          <BusinessFilterCheckboxes />
                        </Box>
                      </Grid>

                      <Grid gridRowGap="32px" gridAutoRows="max-content">
                        <div>
                          <Grid
                            gridRowGap="32px"
                            gridAutoRows="max-content"
                            padding="8px"
                          >
                            <Box>
                              <FilterHeader>
                                Broker co-op{" "}
                                
                              </FilterHeader>
                              <Flex>
                                <Checkbox
                                  mr="5px"
                                  isChecked={tempBrokerCoop}
                                  onChange={(e) => {
                                    setTempBrokerCoop(e.target.checked);
                                  }}
                                  colorScheme="green"
                                >
                                  Only show broker co-op listings
                                </Checkbox>
                              </Flex>
                            </Box>

                            <Box>
                              <FilterHeader>
                                Posted by
                             
                              </FilterHeader>

                              <RadioGroup
                                onChange={(val) => {
                                  setTempPostedBy(val);
                                }}
                                // value={values[name] ? values[name] : initialValues[name]}
                                value={tempPostedBy}
                              >
                                <Stack>
                                  {postedByOptions.map((type, index) => (
                                    <Radio
                                      defaultChecked={
                                        tempPostedBy == type["value"]
                                      }
                                      key={index}
                                      colorScheme="green"
                                      value={type["value"]}
                                    >
                                      {type["label"]}
                                    </Radio>
                                  ))}
                                </Stack>
                              </RadioGroup>
                            </Box>
                          </Grid>
                        </div>

                        {/* Price */}
                        <Box maxW={"100%"}>
                          <FilterHeader>Price</FilterHeader>
                          <Grid
                            gridTemplateColumns={"1fr 1fr"}
                            gridColumnGap="16px"
                            width="100%"
                            // gridTemplateColumns={'1fr 1fr'}
                          >
                            {/* Price */}
                            <div>
                              <MyFormFakeLabel
                                active={queryState["price"]?.length == 2}
                              >
                                Min price
                              </MyFormFakeLabel>

                              <InputWrapper>
                                <NumberFormat
                                  thousandSeparator={true}
                                  prefix={"$"}
                                  value={unFormLowPrice}
                                  className={styles.HiLoInput}
                                  allowEmptyFormatting={true}
                                  allowNegative={false}
                                  autoComplete="off"
                                  onValueChange={(values) => {
                                    const { floatValue } = values;
                                    floatValue?.toString().length > 0
                                      ? setunFormLowPrice(floatValue)
                                      : setunFormLowPrice(null);
                                  }}
                                  style={{
                                    border: "1px solid #CBD5E0",
                                    borderRadius: "0.375rem",
                                    padding: "0.5rem 1rem",
                                    width: "100%",
                                    outline: "none",
                                    transition: "all 0.3s",
                                  }}
                                />
                                <IncrementHolder>
                                  <IconButton
                                    tabIndex={-1}
                                    onClick={() =>
                                      setunFormLowPrice(
                                        unFormLowPrice
                                          ? unFormLowPrice + 100000
                                          : 100000
                                      )
                                    }
                                    bg="white"
                                    size="xs"
                                    _focus={{
                                      boxShadow: "none",
                                    }}
                                    icon={<TriangleUpIcon />}
                                    display="flex"
                                    aria-label="Increment up 100k"
                                    justifyContent="center"
                                    alignItems="center"
                                    flex={1}
                                    transition="all 0.3s"
                                    userSelect="none"
                                    cursor="pointer"
                                    lineHeight="normal"
                                    borderLeft="1px solid"
                                    borderColor="inherit"
                                    fontSize="15px"
                                    borderTopRightRadius="3px"
                                  />

                                  <IconButton
                                    tabIndex={-1}
                                    onClick={() =>
                                      unFormLowPrice >= 100000
                                        ? setunFormLowPrice(
                                            unFormLowPrice - 100000
                                          )
                                        : null
                                    }
                                    bg="white"
                                    size="xs"
                                    _focus={{
                                      boxShadow: "none",
                                    }}
                                    icon={<TriangleDownIcon />}
                                    display="flex"
                                    aria-label="Increment up 100k"
                                    justifyContent="center"
                                    alignItems="center"
                                    flex={1}
                                    transition="all 0.3s"
                                    userSelect="none"
                                    cursor="pointer"
                                    lineHeight="normal"
                                    borderLeft="1px solid"
                                    borderColor="inherit"
                                    fontSize="15px"
                                    borderBottomRightRadius="3px"
                                    marginTop="-1px"
                                    borderTopWidth="1px"
                                  />
                                </IncrementHolder>
                              </InputWrapper>
                            </div>

                            <div>
                              <MyFormFakeLabel
                                active={queryState["price"]?.length == 2}
                              >
                                Max price
                              </MyFormFakeLabel>
                              <InputWrapper>
                                <NumberFormat
                                  thousandSeparator={true}
                                  prefix={"$"}
                                  value={unFormHighPrice}
                                  onValueChange={(values) => {
                                    const { floatValue } = values;
                                    floatValue?.toString().length > 0
                                      ? setunFormHighPrice(floatValue)
                                      : setunFormHighPrice(null);
                                  }}
                                  className={styles.HiLoInput}
                                  allowEmptyFormatting={true}
                                  allowNegative={false}
                                  color={"#125F3F"}
                                  style={{
                                    outline: "#125F3F",
                                    paddingLeft: "1rem",
                                    paddingRight: "1rem",
                                  }}
                                />
                                <IncrementHolder>
                                  <IconButton
                                    tabIndex={-1}
                                    onClick={() =>
                                      setunFormHighPrice(
                                        unFormHighPrice
                                          ? unFormHighPrice + 100000
                                          : 100000
                                      )
                                    }
                                    bg="white"
                                    size="xs"
                                    _focus={{
                                      boxShadow: "none",
                                    }}
                                    icon={<TriangleUpIcon />}
                                    display="flex"
                                    aria-label="Increment up 100k"
                                    justifyContent="center"
                                    alignItems="center"
                                    flex={1}
                                    transition="all 0.3s"
                                    userSelect="none"
                                    cursor="pointer"
                                    lineHeight="normal"
                                    borderLeft="1px solid"
                                    borderColor="inherit"
                                    fontSize="15px"
                                    borderTopRightRadius="3px"
                                  />

                                  <IconButton
                                    tabIndex={-1}
                                    onClick={() =>
                                      unFormHighPrice >= 100000
                                        ? setunFormHighPrice(
                                            unFormHighPrice - 100000
                                          )
                                        : null
                                    }
                                    bg="white"
                                    size="xs"
                                    _focus={{
                                      boxShadow: "none",
                                    }}
                                    icon={<TriangleDownIcon />}
                                    display="flex"
                                    aria-label="Increment up 100k"
                                    justifyContent="center"
                                    alignItems="center"
                                    flex={1}
                                    transition="all 0.3s"
                                    userSelect="none"
                                    cursor="pointer"
                                    lineHeight="normal"
                                    borderLeft="1px solid"
                                    borderColor="inherit"
                                    fontSize="15px"
                                    borderBottomRightRadius="3px"
                                    marginTop="-1px"
                                    borderTopWidth="1px"
                                  />
                                </IncrementHolder>
                              </InputWrapper>

                              {unFormHighPrice < unFormLowPrice && (
                                <Disclaimer>
                                  Max price must be greater than min
                                </Disclaimer>
                              )}
                            </div>
                          </Grid>
                        </Box>

                        {/* Cap */}
                        {queryState["type"] != "For Lease" && (
                          <Box>
                            <FilterHeader>CAP Rate</FilterHeader>
                            <Grid
                              gridColumnGap="16px"
                              width="100%"
                              gridTemplateColumns={"1fr 1fr"}
                            >
                              <div>
                                <MyFormFakeLabel
                                  active={queryState["cap"]?.length == 2}
                                >
                                  Min CAP
                                </MyFormFakeLabel>

                                <InputWrapper>
                                  <NumberFormat
                                    thousandSeparator={true}
                                    suffix={"%"}
                                    value={capLow}
                                    className={styles.HiLoInput}
                                    allowEmptyFormatting={true}
                                    allowNegative={false}
                                    color={"#125F3F"}
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      floatValue?.toString().length > 0
                                        ? setCapLow(floatValue)
                                        : setCapLow(null);
                                    }}
                                    style={{
                                      outline: "#125F3F",
                                      paddingLeft: "1rem",
                                      paddingRight: "1rem",
                                    }}
                                  />
                                  <IncrementHolder>
                                    <IconButton
                                      tabIndex={-1}
                                      onClick={() =>
                                        setCapLow(capLow ? capLow + 1 : 1)
                                      }
                                      bg="white"
                                      size="xs"
                                      _focus={{
                                        boxShadow: "none",
                                      }}
                                      icon={<TriangleUpIcon />}
                                      display="flex"
                                      aria-label="Increment up 100k"
                                      justifyContent="center"
                                      alignItems="center"
                                      flex={1}
                                      transition="all 0.3s"
                                      userSelect="none"
                                      cursor="pointer"
                                      lineHeight="normal"
                                      borderLeft="1px solid"
                                      borderColor="inherit"
                                      fontSize="15px"
                                      borderTopRightRadius="3px"
                                    />

                                    <IconButton
                                      tabIndex={-1}
                                      onClick={() =>
                                        capLow >= 1
                                          ? setCapLow(capLow - 1)
                                          : null
                                      }
                                      bg="white"
                                      size="xs"
                                      _focus={{
                                        boxShadow: "none",
                                      }}
                                      icon={<TriangleDownIcon />}
                                      display="flex"
                                      aria-label="Increment up 100k"
                                      justifyContent="center"
                                      alignItems="center"
                                      flex={1}
                                      transition="all 0.3s"
                                      userSelect="none"
                                      cursor="pointer"
                                      lineHeight="normal"
                                      borderLeft="1px solid"
                                      borderColor="inherit"
                                      fontSize="15px"
                                      borderBottomRightRadius="3px"
                                      marginTop="-1px"
                                      borderTopWidth="1px"
                                    />
                                  </IncrementHolder>
                                </InputWrapper>
                              </div>

                              <div>
                                <MyFormFakeLabel
                                  active={queryState["cap"]?.length == 2}
                                >
                                  Max CAP
                                </MyFormFakeLabel>
                                <InputWrapper>
                                  <NumberFormat
                                    thousandSeparator={true}
                                    suffix={"%"}
                                    value={capHigh}
                                    className={styles.HiLoInput}
                                    allowEmptyFormatting={true}
                                    allowNegative={false}
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      floatValue?.toString().length > 0
                                        ? setCapHigh(floatValue)
                                        : setCapHigh(null);
                                    }}
                                    color={"#125F3F"}
                                    style={{
                                      outline: "#125F3F",
                                      paddingLeft: "1rem",
                                      paddingRight: "1rem",
                                    }}
                                  />
                                  <IncrementHolder>
                                    <IconButton
                                      tabIndex={-1}
                                      onClick={() =>
                                        setCapHigh(capHigh ? capHigh + 1 : 1)
                                      }
                                      bg="white"
                                      size="xs"
                                      _focus={{
                                        boxShadow: "none",
                                      }}
                                      icon={<TriangleUpIcon />}
                                      display="flex"
                                      aria-label="Increment up 100k"
                                      justifyContent="center"
                                      alignItems="center"
                                      flex={1}
                                      transition="all 0.3s"
                                      userSelect="none"
                                      cursor="pointer"
                                      lineHeight="normal"
                                      borderLeft="1px solid"
                                      borderColor="inherit"
                                      fontSize="15px"
                                      borderTopRightRadius="3px"
                                    />

                                    <IconButton
                                      tabIndex={-1}
                                      onClick={() =>
                                        capHigh >= 1
                                          ? setCapHigh(capHigh - 1)
                                          : null
                                      }
                                      bg="white"
                                      size="xs"
                                      _focus={{
                                        boxShadow: "none",
                                      }}
                                      icon={<TriangleDownIcon />}
                                      display="flex"
                                      aria-label="Increment up 100k"
                                      justifyContent="center"
                                      alignItems="center"
                                      flex={1}
                                      transition="all 0.3s"
                                      userSelect="none"
                                      cursor="pointer"
                                      lineHeight="normal"
                                      borderLeft="1px solid"
                                      borderColor="inherit"
                                      fontSize="15px"
                                      borderBottomRightRadius="3px"
                                      marginTop="-1px"
                                      borderTopWidth="1px"
                                    />
                                  </IncrementHolder>
                                </InputWrapper>
                                {capHigh < capLow && (
                                  <Disclaimer>
                                    Max CAP must be greater than min
                                  </Disclaimer>
                                )}
                              </div>
                            </Grid>
                          </Box>
                        )}

                        {/* Size */}
                        <Box>
                          <FilterHeader>Property size</FilterHeader>
                          <Grid gridRowGap="16px">
                            <div>
                              <MyFormFakeLabel
                                active={queryState["sqft"]?.length == 2}
                              >
                                Square footage
                              </MyFormFakeLabel>
                              <Grid
                                gridTemplateColumns={"1fr 1fr"}
                                gridColumnGap="16px"
                                width="100%"
                                // gridTemplateColumns={'1fr 1fr'}
                              >
                                <InputWrapper>
                                  <NumberFormat
                                    thousandSeparator={true}
                                    value={unFormLowSize}
                                    placeholder="Min SF"
                                    className={styles.HiLoInput}
                                    allowEmptyFormatting={true}
                                    allowNegative={false}
                                    color={"#125F3F"}
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      floatValue?.toString().length > 0
                                        ? setunFormLowSize(floatValue)
                                        : setunFormLowSize(null);
                                    }}
                                    style={{
                                      outline: "#125F3F",
                                      paddingLeft: "1rem",
                                      paddingRight: "1rem",
                                    }}
                                  />
                                </InputWrapper>

                                <InputWrapper>
                                  <NumberFormat
                                    thousandSeparator={true}
                                    value={unFormHighSize}
                                    placeholder="Max SF"
                                    className={styles.HiLoInput}
                                    allowEmptyFormatting={true}
                                    allowNegative={false}
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      floatValue?.toString().length > 0
                                        ? setunFormHighSize(floatValue)
                                        : setunFormHighSize(null);
                                    }}
                                    color={"#125F3F"}
                                    style={{
                                      outline: "#125F3F",
                                      paddingLeft: "1rem",
                                      paddingRight: "1rem",
                                    }}
                                  />
                                </InputWrapper>
                              </Grid>

                              {unFormHighSize < unFormLowSize && (
                                <Disclaimer>
                                  Max SQ FT must be greater than min
                                </Disclaimer>
                              )}
                            </div>

                            <div>
                              <MyFormFakeLabel
                                active={queryState["acres"]?.length == 2}
                              >
                                Lot size (acreage){" "}
                              </MyFormFakeLabel>
                              <Grid
                                gridTemplateColumns={"1fr 1fr"}
                                gridColumnGap="16px"
                                width="100%"
                                // gridTemplateColumns={'1fr 1fr'}
                              >
                                <InputWrapper>
                                  <NumberFormat
                                    thousandSeparator={true}
                                    value={unFormLowAcres}
                                    placeholder="Min Acres"
                                    className={styles.HiLoInput}
                                    allowEmptyFormatting={true}
                                    allowNegative={false}
                                    color={"#125F3F"}
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      floatValue?.toString().length > 0
                                        ? setunFormLowAcres(floatValue)
                                        : setunFormLowAcres(null);
                                    }}
                                    style={{
                                      outline: "#125F3F",
                                      paddingLeft: "1rem",
                                      paddingRight: "1rem",
                                    }}
                                  />
                                </InputWrapper>

                                <InputWrapper>
                                  <NumberFormat
                                    thousandSeparator={true}
                                    value={unFormHighAcres}
                                    placeholder="Max Acres"
                                    className={styles.HiLoInput}
                                    allowEmptyFormatting={true}
                                    allowNegative={false}
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      floatValue?.toString().length > 0
                                        ? setunFormHighAcres(floatValue)
                                        : setunFormHighAcres(null);
                                    }}
                                    color={"#125F3F"}
                                    style={{
                                      outline: "#125F3F",
                                      paddingLeft: "1rem",
                                      paddingRight: "1rem",
                                    }}
                                  />
                                </InputWrapper>
                              </Grid>
                              {unFormHighAcres < unFormLowAcres && (
                                <Disclaimer>
                                  Max acres must be greater than min
                                </Disclaimer>
                              )}
                            </div>
                          </Grid>
                        </Box>

                        <Box>
                          <FilterHeader>Listing details</FilterHeader>
                          <Grid gridRowGap="32px">
                            <Grid gridRowGap="16px">
                              <Checkbox
                                isChecked={tempOffMarket}
                                onChange={(e) => {
                                  setTempOffMarket(e.target.checked);
                                }}
                                colorScheme="green"
                              >
                                Off-market only (Not on MLS®)
                              </Checkbox>
                            </Grid>
                          </Grid>
                        </Box>

                        <Box>
                          <FilterHeader>Timeline</FilterHeader>
                          <ChakraSelect
                            placeholder="Show listings posted in the last:"
                            focusBorderColor="green.500"
                            value={tempTimeline}
                            onChange={(e) => {
                              setTempTimeline(e.target.value);
                            }}
                          >
                            {dateUploadedOptions.map((i) => (
                              <option key={i["value"]} value={i["value"]}>
                                {i["label"]}
                              </option>
                            ))}
                          </ChakraSelect>
                        </Box>

                        <Box>
                          <FilterHeader>Sort results</FilterHeader>
                          <ChakraSelect
                            placeholder="Sort listings by"
                            focusBorderColor="green.500"
                            value={tempSortBy}
                            onChange={(e) => {
                              setTempSortBy(e.target.value);
                            }}
                          >
                            {sortByOptions.map((i) => (
                              <option key={i["value"]} value={i["value"]}>
                                {i["label"]}
                              </option>
                            ))}
                          </ChakraSelect>
                        </Box>
                      </Grid>
                    </Grid>
                  </DrawerBody>
                  <DrawerFooter
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Clearer />
                    </Box>

                    <Flex gridColumnGap="16px">
                      <ApplyFilters type="apply" />
                      <ApplyFilters
                        // onClose={onClose}
                        type="andSave"
                      />
                    </Flex>
                  </DrawerFooter>
                </DrawerContent>
              </Drawer>

              {/* All filters */}
              <FilterHolder>
                <FilterShell>
                  <TopFiltersHolder
                    ref={scroller}
                    transform={`translateX(${translatePixels + "px"})`}
                    style={{
                      transform: `translateX(${translatePixels + "px"})`,
                    }}
                  >
                    <Button
                      onClick={() => {
                        setIsFilterDrawerOpen(true);
                      }}
                      _focus={{
                        boxShadow: "none",
                      }}
                      _hover={{
                        backgroundColor: "myGray.50",
                      }}
                      _active={{
                        backgroundColor: "myGray.300",
                      }}
                      mr="8px"
                      fontWeight="501"
                      height="2.25rem"
                      fontSize="0.875rem"
                      borderRadius="20px"
                      paddingX="1.1rem"
                      variant="ghost"
                      rightIcon={<ChevronDownIcon />}
                      leftIcon={<MdSettings />}
                      // Ignore page count from active queries
                      color={
                        actualFiltersCount > 0 ? "brand.900" : "myGray.200"
                      }
                    >
                      All filters{" "}
                      {actualFiltersCount > 0
                        ? `(${actualFiltersCount})`
                        : ""}
                    </Button>

                    <Clearer />

                    <Button
                      _focus={{
                        boxShadow: "none",
                      }}
                      _hover={{
                        backgroundColor: "myGray.50",
                      }}
                      _active={{
                        backgroundColor: "myGray.300",
                      }}
                      mr="8px"
                      fontWeight="501"
                      height="2.25rem"
                      // colorScheme={values['offMarket'] ? 'green' : ''}
                      // variant={values['offMarket'] ? 'solid' : 'outline'}
                      backgroundColor={
                        queryState["offMarket"] === true
                          ? "green.100"
                          : "white"
                      }
                      fontSize="0.875rem"
                      borderRadius="20px"
                      paddingX="1.1rem"
                      color={
                        queryState["offMarket"] === true
                          ? "brand.900"
                          : "myGray.200"
                      }
                      variant="outline"
                      // display={{ base: "inline-flex", xl: "none" }}
                      // leftIcon={MdOutlineOfflineBolt}
                      borderColor={
                        queryState["offMarket"] === true
                          ? "brand.900"
                          : "myGray.100"
                      }
                      onClick={() => {
                        if (queryState["offMarket"] === true) {
                          // setFieldValue("offMarket", []);
                          updateListingFilters({
                            ...queryState,
                            offMarket: [],
                          });
                          setTempOffMarket(false);

                          clientAnalytics.track(
                            "Filtered for off-market listings"
                          );
                        } else {
                          updateListingFilters({
                            ...queryState,
                            offMarket: true,
                          });
                          // setFieldValue("offMarket", true);
                          setTempOffMarket(true);
                        }
                      }}
                    >
                      Off-market only
                    </Button>

                    <Button
                      _focus={{
                        boxShadow: "none",
                      }}
                      _hover={{
                        backgroundColor: "myGray.50",
                      }}
                      _active={{
                        backgroundColor: "myGray.300",
                      }}
                      mr="8px"
                      fontWeight="501"
                      height="2.25rem"
                      fontSize="0.875rem"
                      borderRadius="20px"
                      paddingX="1.1rem"
                      color="myGray.200"
                      variant="outline"
                      display={{ base: "inline-flex", xl: "none" }}
                      rightIcon={<ChevronDownIcon />}
                      borderColor={
                        queryState?.propertyType?.length > 0 ||
                        queryState?.subType?.length > 0
                          ? "brand.900"
                          : "myGray.100"
                      }
                      onClick={() => {
                        setDefaultIndexNum([0]);
                        onDrawerOpen();
                      }}
                      leftIcon={<RiBuilding2Fill />}
                    >
                      Type
                    </Button>

                    <Button
                      _focus={{
                        boxShadow: "none",
                      }}
                      _hover={{
                        backgroundColor: "myGray.50",
                      }}
                      _active={{
                        backgroundColor: "myGray.300",
                      }}
                      mr="8px"
                      fontWeight="501"
                      height="2.25rem"
                      fontSize="0.875rem"
                      borderRadius="20px"
                      paddingX="1.1rem"
                      color="myGray.200"
                      variant="outline"
                      display={{ base: "inline-flex", xl: "none" }}
                      rightIcon={<ChevronDownIcon />}
                      borderColor={
                        queryState?.businessCategory?.length > 0 ||
                        queryState?.businessType?.length > 0
                          ? "brand.900"
                          : "myGray.100"
                      }
                      onClick={() => {
                        // Change the others if you change this
                        setDefaultIndexNum([1]);
                        onDrawerOpen();
                      }}
                      leftIcon={<MdOutlineAddBusiness />}
                    >
                      Businesses
                    </Button>

                    <Button
                      _focus={{
                        boxShadow: "none",
                      }}
                      _hover={{
                        backgroundColor: "myGray.50",
                      }}
                      _active={{
                        backgroundColor: "myGray.300",
                      }}
                      mr="8px"
                      fontWeight="501"
                      height="2.25rem"
                      fontSize="0.875rem"
                      borderRadius="20px"
                      paddingX="1.1rem"
                      display={{ base: "inline-flex", xl: "none" }}
                      color="myGray.200"
                      variant="outline"
                      leftIcon={<FaFileContract />}
                      rightIcon={<ChevronDownIcon />}
                      borderColor={
                        queryState?.type?.length > 0
                          ? "brand.900"
                          : "myGray.100"
                      }
                      onClick={() => {
                        setDefaultIndexNum([2]);
                        onDrawerOpen();
                      }}
                    >
                      Sale/Lease
                    </Button>

                    <Button
                      _focus={{
                        boxShadow: "none",
                      }}
                      _hover={{
                        backgroundColor: "myGray.50",
                      }}
                      _active={{
                        backgroundColor: "myGray.300",
                      }}
                      mr="8px"
                      fontWeight="501"
                      height="2.25rem"
                      fontSize="0.875rem"
                      borderRadius="20px"
                      paddingX="1.1rem"
                      color="myGray.200"
                      display={{ base: "inline-flex", xl: "none" }}
                      variant="outline"
                      rightIcon={<ChevronDownIcon />}
                      borderColor={
                        queryState?.price?.length > 0 &&
                        queryState?.price !== minMaxState
                          ? "brand.900"
                          : "myGray.100"
                      }
                      leftIcon={<MdAttachMoney />}
                      onClick={() => {
                        setDefaultIndexNum([3]);
                        onDrawerOpen();
                      }}
                    >
                      Price
                    </Button>
                    {/* propertyType */}
                    <Popover placement="bottom" closeOnBlur={true}>
                      {({ isOpen, onClose }) => (
                        <>
                          <PopoverTrigger>
                            <Button
                              _focus={{
                                boxShadow: "none",
                              }}
                              _hover={{
                                backgroundColor: "myGray.50",
                              }}
                              _active={{
                                backgroundColor: "myGray.300",
                              }}
                              mr="8px"
                              fontWeight="501"
                              height="2.25rem"
                              fontSize="0.875rem"
                              borderRadius="20px"
                              paddingX="1.1rem"
                              color="myGray.200"
                              variant="outline"
                              rightIcon={<ChevronDownIcon />}
                              borderColor={
                                queryState?.propertyType?.length ||
                                queryState?.subType?.length > 0
                                  ? "brand.900"
                                  : "myGray.100"
                              }
                              display={{ base: "none", xl: "inline-flex" }}
                              leftIcon={<RiBuilding2Fill />}
                            >
                              Type
                            </Button>
                          </PopoverTrigger>
                          <>
                            <PopoverContent
                              _focus={{
                                boxShadow:
                                  "0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)",
                              }}
                              zIndex={2}
                              // color="white"
                              bg="white"
                              boxShadow="0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)"
                              borderColor="white"
                              maxH="calc(100vh - 134px)"
                            >
                              <PopoverHeader
                                className={listingStyles.popheader}
                              >
                                Select Property Type
                              </PopoverHeader>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverBody overflow="auto">
                                <PropertyTypeFilterCheckboxes />
                              </PopoverBody>
                              <PopoverFooter
                                border="0"
                                display="flex"
                                alignItems="center"
                                justifyContent="flex-end"
                                pb={4}
                              >
                                <ButtonGroup size="sm">
                                  <Button
                                    // isDisabled={values['propertyType']?.length == 0 && values['subType']?.length == 0}
                                    onClick={() => {
                                      // setFieldValue("propertyType", []);
                                      // setFieldValue("subType", []);
                                      updateListingFilters({
                                        ...queryState,
                                        propertyType: [],
                                        subType: [],
                                      });
                                      setPropertyTypeChecked([]);
                                      setSubTypeChecked([]);
                                      setExpandedSubTypes([]);
                                      onClose();
                                    }}
                                    size="sm"
                                    // color="green.500"
                                    colorScheme="green"
                                    variant="ghost"
                                  >
                                    Clear
                                  </Button>
                                  <Button
                                    onClick={() => {
                                      let propertyTypeArr = [];
                                      let subTypeArr = [];

                                      let filteredTypes = Object.keys(
                                        propertyTypeChecked
                                      ).forEach((key) => {
                                        if (propertyTypeChecked[key]) {
                                          propertyTypeArr.push(key);
                                        }
                                      });
                                      let filteredSubTypes = Object.keys(
                                        subTypeChecked
                                      ).forEach((key) => {
                                        if (subTypeChecked[key]?.length > 0) {
                                          subTypeArr = [
                                            ...subTypeArr,
                                            ...subTypeChecked[key],
                                          ];
                                        }
                                      });

                                      updateListingFilters({
                                        ...queryState,
                                        propertyType: propertyTypeArr,
                                        subType: subTypeArr,
                                      });
                                      // setFieldValue(
                                      //   "propertyType",
                                      //   propertyTypeArr
                                      // );
                                      // setFieldValue("subType", subTypeArr);
                                      onClose();
                                    }}
                                    leftIcon={<CheckCircleIcon />}
                                    size="sm"
                                    colorScheme="green"
                                    // color="green.500"
                                    variant="solid"
                                  >
                                    Apply
                                  </Button>
                                </ButtonGroup>
                              </PopoverFooter>
                            </PopoverContent>
                          </>
                        </>
                      )}
                    </Popover>

                    {/* Business */}
                    <Popover placement="bottom" closeOnBlur={true}>
                      {({ isOpen, onClose }) => (
                        <>
                          <PopoverTrigger>
                            <Button
                              _focus={{
                                boxShadow: "none",
                              }}
                              _hover={{
                                backgroundColor: "myGray.50",
                              }}
                              _active={{
                                backgroundColor: "myGray.300",
                              }}
                              mr="8px"
                              fontWeight="501"
                              height="2.25rem"
                              fontSize="0.875rem"
                              borderRadius="20px"
                              paddingX="1.1rem"
                              color="myGray.200"
                              variant="outline"
                              rightIcon={<ChevronDownIcon />}
                              borderColor={
                                queryState?.businessCategory?.length ||
                                queryState?.businessType?.length > 0
                                  ? "brand.900"
                                  : "myGray.100"
                              }
                              display={{ base: "none", xl: "inline-flex" }}
                              leftIcon={<MdOutlineAddBusiness />}
                            >
                              Businesses
                            </Button>
                          </PopoverTrigger>
                          <>
                            <PopoverContent
                              _focus={{
                                boxShadow:
                                  "0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)",
                              }}
                              zIndex={2}
                              // color="white"
                              bg="white"
                              boxShadow="0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)"
                              borderColor="white"
                              maxH="calc(100vh - 134px)"
                            >
                              <PopoverHeader
                                className={listingStyles.popheader}
                              >
                                Select Businesses
                              </PopoverHeader>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverBody overflow="auto">
                                <BusinessFilterCheckboxes />
                              </PopoverBody>
                              <PopoverFooter
                                border="0"
                                display="flex"
                                alignItems="center"
                                justifyContent="flex-end"
                                pb={4}
                              >
                                <ButtonGroup size="sm">
                                  <Button
                                    // isDisabled={values['propertyType']?.length == 0 && values['subType']?.length == 0}
                                    onClick={() => {
                                      // setFieldValue("propertyType", []);
                                      // setFieldValue("subType", []);
                                      updateListingFilters({
                                        ...queryState,
                                        businessCategory: [],
                                        businessType: [],
                                      });
                                      setBusinessCategoryChecked([]);
                                      setBusinessTypeChecked([]);
                                      setExpandedBusinessTypes([]);
                                      onClose();
                                    }}
                                    size="sm"
                                    // color="green.500"
                                    colorScheme="green"
                                    variant="ghost"
                                  >
                                    Clear
                                  </Button>
                                  <Button
                                    onClick={() => {
                                      let businessCategoryArr = [];
                                      let businessTypeArr = [];

                                      let filteredBusinessCategories =
                                        Object.keys(
                                          businessCategoryChecked
                                        ).forEach((key) => {
                                          if (businessCategoryChecked[key]) {
                                            businessCategoryArr.push(key);
                                          }
                                        });
                                      let filteredBusinessTypes = Object.keys(
                                        businessTypeChecked
                                      ).forEach((key) => {
                                        if (
                                          businessTypeChecked[key]?.length > 0
                                        ) {
                                          businessTypeArr = [
                                            ...businessTypeArr,
                                            ...businessTypeChecked[key],
                                          ];
                                        }
                                      });

                                      updateListingFilters({
                                        ...queryState,
                                        businessCategory: businessCategoryArr,
                                        businessType: businessTypeArr,
                                      });
                                      // setFieldValue(
                                      //   "businessCategory",
                                      //   businessCategoryArr
                                      // );
                                      // setFieldValue("businessType", businessTypeArr);
                                      onClose();
                                    }}
                                    leftIcon={<CheckCircleIcon />}
                                    size="sm"
                                    colorScheme="green"
                                    // color="green.500"
                                    variant="solid"
                                  >
                                    Apply
                                  </Button>
                                </ButtonGroup>
                              </PopoverFooter>
                            </PopoverContent>
                          </>
                        </>
                      )}
                    </Popover>

                       {/* Transaction Type */}
                       <Popover placement="bottom" closeOnBlur={true}>
                      {({ onClose }) => (
                        <>
                          <PopoverTrigger>
                            <Button
                              _focus={{
                                boxShadow: "none",
                              }}
                              _hover={{
                                backgroundColor: "myGray.50",
                              }}
                              _active={{
                                backgroundColor: "myGray.300",
                              }}
                              mr="8px"
                              fontWeight="501"
                              height="2.25rem"
                              fontSize="0.875rem"
                              borderRadius="20px"
                              paddingX="1.1rem"
                              color="myGray.200"
                              variant="outline"
                              leftIcon={<FaFileContract />}
                              borderColor={
                                queryState?.type?.length > 0
                                  ? "brand.900"
                                  : "myGray.100"
                              }
                              display={{ base: "none", xl: "inline-flex" }}
                              rightIcon={<ChevronDownIcon />}
                            >
                              Sale/Lease
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent
                            _focus={{
                              boxShadow:
                                "0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)",
                            }}
                            zIndex={2}
                            // color="white"
                            bg="white"
                            boxShadow="0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)"
                            borderColor="white"
                            maxH="calc(100vh - 134px)"
                          >
                            <PopoverHeader
                              className={listingStyles.popheader}
                            >
                              Sale/Lease
                            </PopoverHeader>
                            <PopoverArrow />
                            <PopoverCloseButton />
                            <PopoverBody overflow="auto">
                              <SmartRadioGroup
                                name="type"
                                options={transactionTypeOptions}
                                label={undefined}
                              />
                            </PopoverBody>
                            <PopoverFooter
                              border="0"
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end"
                              pb={4}
                            >
                              <Button
                                isDisabled={queryState["type"]?.length === 0}
                                onClick={() => {
                                  updateListingFilters({
                                    ...queryState,
                                    type: [],
                                  });
                                  onClose();
                                  // setFieldValue("type", []);
                                }}
                                size="sm"
                                color="green.500"
                                variant="ghost"
                              >
                                Clear
                              </Button>
                            </PopoverFooter>
                          </PopoverContent>
                        </>
                      )}
                    </Popover>



                  
                    {/*Keyword search */}
                    {/* <SmartInput 
                                                  name="keyword"
                                              /> */}

                    <Button
                      _focus={{
                        boxShadow: "none",
                      }}
                      _hover={{
                        backgroundColor: "myGray.50",
                      }}
                      _active={{
                        backgroundColor: "myGray.300",
                      }}
                      mr="8px"
                      fontWeight="501"
                      height="2.25rem"
                      fontSize="0.875rem"
                      borderRadius="20px"
                      paddingX="1.1rem"
                      display={{ base: "inline-flex", xl: "none" }}
                      color="myGray.200"
                      variant="outline"
                      rightIcon={<ChevronDownIcon />}
                      leftIcon={<RepeatClockIcon />}
                      onClick={() => {
                        setDefaultIndexNum([4]);
                        onDrawerOpen();
                      }}
                      borderColor={
                        queryState?.timeline?.length > 0
                          ? "brand.900"
                          : "myGray.100"
                      }
                    >
                      Timeline
                    </Button>

                    {/* Timeline */}
                    <Popover placement="bottom" closeOnBlur={true}>
                      {({ onClose }) => (
                        <>
                          <PopoverTrigger>
                            <Button
                              _focus={{
                                boxShadow: "none",
                              }}
                              _hover={{
                                backgroundColor: "myGray.50",
                              }}
                              _active={{
                                backgroundColor: "myGray.300",
                              }}
                              mr="8px"
                              fontWeight="501"
                              height="2.25rem"
                              fontSize="0.875rem"
                              borderRadius="20px"
                              paddingX="1.1rem"
                              color="myGray.200"
                              variant="outline"
                              rightIcon={<ChevronDownIcon />}
                              leftIcon={<RepeatClockIcon />}
                              display={{ base: "none", xl: "inline-flex" }}
                              borderColor={
                                queryState?.timeline?.length > 0
                                  ? "brand.900"
                                  : "myGray.100"
                              }
                            >
                              Timeline
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent
                            _focus={{
                              boxShadow:
                                "0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)",
                            }}
                            zIndex={2}
                            // color="white"
                            bg="white"
                            boxShadow="0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)"
                            borderColor="white"
                            maxH="calc(100vh - 134px)"
                          >
                            <PopoverHeader
                              className={listingStyles.popheader}
                            >
                              Listing Timeline
                            </PopoverHeader>
                            <PopoverArrow />
                            <PopoverCloseButton />
                            <PopoverBody overflow="auto">
                              <SmartRadioGroup
                                name="timeline"
                                options={dateUploadedOptions}
                                label={undefined}
                              />
                            </PopoverBody>
                            <PopoverFooter
                              border="0"
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end"
                              pb={4}
                            >
                              <Button
                                isDisabled={
                                  queryState["timeline"]?.length === 0
                                }
                                onClick={() => {
                                  updateListingFilters({
                                    ...queryState,
                                    timeline: [],
                                  });
                                  onClose();
                                  // setFieldValue("timeline", []);
                                }}
                                size="sm"
                                color="green.500"
                                variant="ghost"
                              >
                                Clear
                              </Button>
                            </PopoverFooter>
                          </PopoverContent>
                        </>
                      )}
                    </Popover>

                    <Button
                      _focus={{
                        boxShadow: "none",
                      }}
                      _hover={{
                        backgroundColor: "myGray.50",
                      }}
                      _active={{
                        backgroundColor: "myGray.300",
                      }}
                      mr="8px"
                      fontWeight="501"
                      height="2.25rem"
                      fontSize="0.875rem"
                      borderRadius="20px"
                      paddingX="1.1rem"
                      display={{ base: "inline-flex", xl: "none" }}
                      color="myGray.200"
                      variant="outline"
                      rightIcon={<ChevronDownIcon />}
                      leftIcon={<MdSort />}
                      onClick={() => {
                        setDefaultIndexNum([5]);
                        onDrawerOpen();
                      }}
                      borderColor={
                        queryState?.sortBy?.length > 0
                          ? "brand.900"
                          : "myGray.100"
                      }
                    >
                      Sort
                    </Button>

                    {/* Sort */}
                    <Popover placement="bottom" closeOnBlur={true}>
                      {({ onClose }) => (
                        <>
                          <PopoverTrigger>
                            <Button
                              _focus={{
                                boxShadow: "none",
                              }}
                              _hover={{
                                backgroundColor: "myGray.50",
                              }}
                              _active={{
                                backgroundColor: "myGray.300",
                              }}
                              mr="8px"
                              fontWeight="501"
                              height="2.25rem"
                              fontSize="0.875rem"
                              borderRadius="20px"
                              paddingX="1.1rem"
                              color="myGray.200"
                              variant="outline"
                              rightIcon={<ChevronDownIcon />}
                              leftIcon={<MdSort />}
                              display={{ base: "none", xl: "inline-flex" }}
                              borderColor={
                                queryState?.sortBy?.length > 0
                                  ? "brand.900"
                                  : "myGray.100"
                              }
                            >
                              Sort
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent
                            _focus={{
                              boxShadow:
                                "0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)",
                            }}
                            zIndex={2}
                            // color="white"
                            bg="white"
                            boxShadow="0 1px 3px 0 rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,  67,.15)"
                            borderColor="white"
                            maxH="calc(100vh - 134px)"
                          >
                            <PopoverHeader
                              className={listingStyles.popheader}
                            >
                              Sort by
                            </PopoverHeader>
                            <PopoverArrow />
                            <PopoverCloseButton />
                            <PopoverBody overflow="auto">
                              <SmartRadioGroup
                                name="sortBy"
                                options={sortByOptions}
                                label={undefined}
                              />
                            </PopoverBody>
                            <PopoverFooter
                              border="0"
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end"
                              pb={4}
                            >
                              <Button
                                isDisabled={
                                  queryState["sortBy"]?.length === 0
                                }
                                onClick={() => {
                                  updateListingFilters({
                                    ...queryState,
                                    sortBy: [],
                                  });
                                  onClose();
                                  // setFieldValue("sortBy", []);
                                }}
                                size="sm"
                                color="green.500"
                                variant="ghost"
                              >
                                Clear
                              </Button>
                            </PopoverFooter>
                          </PopoverContent>
                        </>
                      )}
                    </Popover>
                  </TopFiltersHolder>
                </FilterShell>
              </FilterHolder>
              <ResultsAndMap>
                {(size.width > 768 || !showMap) && (
                  <Results showMap={showMap}>
                    <FilterTagsMemoized />
                    <HeaderHolder
                      staticStatus={staticStatus}
                      staticHeader={staticHeader}
                    >
                      <MainHeader>
                        {staticHeader && staticStatus
                          ? staticHeader
                          : "New listings"}
                      </MainHeader>

                      <SavetheSearch />
                      <Flex
                        tabIndex={-1}
                        justify="flex-start"
                        align="center"
                        mb="1px"
                      >
                        <FormLabel mb="0px" htmlFor="showMap" fontWeight="400" fontSize="14px">
                         Map
                        </FormLabel>
                        <Switch
                          tabIndex={-1}
                          isChecked={showMap}
                          colorScheme="green"
                          id="showMap"
                          onChange={(e) => setShowMap(!showMap)}
                        />
                      </Flex>
                  
                    </HeaderHolder>

                    {staticDesc && (
                      <HeaderStaticDesc>{staticDesc}</HeaderStaticDesc>
                    )}

                    {status === "loading" && (
                      <ListingsSpinnerHolder>
                        <Spinner size="xl" color="green.800" />
                      </ListingsSpinnerHolder>
                    )}

                    {status === "error" && (
                      <StateSvg
                        svg="/images/search/errorState.svg"
                        heading="Error"
                        subHeading="Oops, looks like we've hit a bug. A report has been sent to our team and we're looking into it now. Try changing filters or checking back soon!"
                      />
                    )}

                    {status === "success" &&
                      (!data["listings"] ||
                        data["listings"]?.length === 0) && (
                        <StateSvg
                          svg="/images/search/emptyState.svg"
                          heading="No matching results"
                          subHeading="Looks like nothing matches that criteria. Try removing filters or clicking 'Save this search' to be notified once we've got something for you!"
                        />
                      )}

                    {size?.width >= 1440 && showMap ?
                      <>
                        <PriorityListingHolderGrid showMap={showMap}>
                          {status === "success" &&
                            categorizedListings?.highPriority?.map((listing, i) => (
                              <ListingCard
                                showMap={showMap}
                                triggerAuth={triggerAuth}
                                order={i}
                                key={listing["id"]}
                                {...listing}
                              />
                            ))}
                        </PriorityListingHolderGrid>

                        <ListingCardHolderGrid showMap={showMap}>
                          {status === "success" &&
                            categorizedListings?.lowPriority?.map((listing, i) => (
                              <ListingCard
                                showMap={false}
                                triggerAuth={triggerAuth}
                                order={i}
                                key={listing["id"]}
                                {...listing}
                              />
                            ))}
                        </ListingCardHolderGrid>
                      </>

                      :
                      <ListingCardHolderGrid showMap={showMap}>
                      {status === "success" &&
                        data['listings']?.map((listing, i) => (
                          <ListingCard
                            showMap={false}
                            triggerAuth={triggerAuth}
                            order={i}
                            key={listing["id"]}
                            {...listing}
                          />
                        ))}
                    </ListingCardHolderGrid>

                    } 

                    {data?.listings?.length > 0 && data?.currentPage && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            margin: "40px 0 20px",
                          }}
                        >
                          {data?.currentPage > 1 && (
                            <Link
                              prefetch={false}
                              href={{
                                pathname: router.pathname,
                                query: {
                                  ...queryState,
                                  page: data.currentPage - 1,
                                },
                              }}>

                              <Button
                                _focus={{
                                  boxShadow: "none",
                                }}
                                mr="10px"
                                onClick={() => {
                                  updateListingFilters({
                                    ...queryState,
                                    page: data.currentPage - 1,
                                  });
                                  // setFieldValue(
                                  //   "page",
                                  //   data.currentPage - 1
                                  // );
                                }}
                                colorScheme="green"
                                variant="outline"
                                leftIcon={<ChevronLeftIcon />}
                              >
                                Previous
                              </Button>

                            </Link>
                          )}

                          {data?.pages > data?.currentPage && (
                            <Link
                              href={{
                                pathname: "/listings",
                                query: {
                                  ...queryState,
                                  page: data.currentPage + 1,
                                },
                              }}
                              prefetch={false}>

                              <Button
                                _focus={{
                                  boxShadow: "none",
                                }}
                                onClick={() => {
                                  updateListingFilters({
                                    ...queryState,
                                    page: data.currentPage + 1,
                                  });
                                  // setFieldValue(
                                  //   "page",
                                  //   data.currentPage + 1
                                  // );
                                }}
                                colorScheme="green"
                                variant="outline"
                                rightIcon={<ChevronRightIcon />}
                              >
                                Next
                              </Button>

                            </Link>
                          )}
                        </div>

                        {data?.pages > 1 && (
                          <PaginationButtonHolder>
                            {[...Array(data?.pages)].map((value, index) => {
                              const listingsPageNumber = index + 1;
                              return (
                                (<Link
                                  key={index}
                                  href={{
                                    pathname: "/listings",
                                    query: {
                                      ...queryState,
                                      page: listingsPageNumber,
                                    },
                                  }}
                                  prefetch={false}>

                                  <Button
                                    onClick={() => {
                                      listingsPageNumber !==
                                      data?.currentPage
                                        ? updateListingFilters({
                                            ...queryState,
                                            page: listingsPageNumber,
                                          })
                                        : // setFieldValue("page", listingsPageNumber) :
                                          null;
                                    }}
                                    colorScheme="green"
                                    variant={
                                      data?.currentPage ===
                                      listingsPageNumber
                                        ? "solid"
                                        : "ghost"
                                    }
                                    borderRadius="50%"
                                    width="2rem"
                                    height="2rem"
                                    mb="5px"
                                    mr="5px"
                                    size="sm"
                                  >
                                    {listingsPageNumber}
                                  </Button>

                                </Link>)
                              );
                            })}
                          </PaginationButtonHolder>
                        )}

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            margin: "16px 0 48px",
                            letterSpacing: "0.2px",
                            color: "#70757a",
                            fontSize: "14px",
                          }}
                        >
                          Showing results {data?.startListing} -{" "}
                          {data?.lastListing} of {data?.countOfListings}
                        </div>
                      </>
                    )}

                    <Box px="8px">
                      {!!(listingFooterText && listingFooterText.length) && (
                        <>
                          {listingFooterText.map((text) => (
                            <Text
                              mt="30px"
                              dangerouslySetInnerHTML={{ __html: text }}
                            ></Text>
                          ))}
                        </>
                      )}

                      {!!linkList1?.length && (
                        <BottomLinks
                          list={linkList1}
                          listHeader={linkList1Header}
                        >
                          {(l1, i) => (
                            <Box mb="6px" key={i}>
                              <Link href={{ pathname: l1["link"] }} prefetch={false}>
                                <SmallFancyLink>{l1["item"]}</SmallFancyLink>
                              </Link>

                              <SmallCount count={l1["itemCount"]} />
                            </Box>
                          )}
                        </BottomLinks>
                      )}

                      {!!(linkList2?.length && linkList2Header) && (
                        <BottomLinks
                          list={linkList2}
                          listHeader={linkList2Header}
                        >
                          {(l2, i) => (
                            <Box mb="6px" key={i}>
                              <Link href={{ pathname: l2["link"] }} prefetch={false}>
                                <SmallFancyLink>{l2["item"]}</SmallFancyLink>
                              </Link>

                              <SmallCount count={l2["itemCount"]} />
                            </Box>
                          )}
                        </BottomLinks>
                      )}

                      {!!(
                        cityListingsByPropertyType &&
                        cityListingsByPropertyType.length
                      ) ? (
                        <>
                          <BottomLinks
                            list={cityListingsByPropertyType}
                            listHeader={"Popular Searches"}
                          >
                            {(cityListing, index) => (
                              <Box mb="6px" key={index}>
                                <Link href={{ pathname: cityListing["link"] }} prefetch={false}>
                                  <SmallFancyLink>
                                    {cityListing.value}
                                  </SmallFancyLink>
                                </Link>

                                <SmallCount
                                  count={cityListing.listingCount}
                                />
                              </Box>
                            )}
                          </BottomLinks>
                        </>
                      ) : null}

                      {!!(staticStatus && province && description) && (
                        <DescriptionWrapper>
                          <SmallFancyBold>
                            About {city ? city : province}
                          </SmallFancyBold>
                          {documentToReactComponents(
                            description["json"],
                            checkRender
                          )}
                        </DescriptionWrapper>
                      )}
                    </Box>
                    {/* Button if page 1 and more listings available, show next only 
                            If page > 1 and more listings available show both next and previous
                            If page > 1 and last page, show only previous
                        */}

                    {/* Text Showing results 1 - X of totalcount  */}
                  </Results>
                )}

                {/* Either size isn't of concern or show map is on */}
                {showMap && <Map>{isLoaded && MapJSX}</Map>}
              </ResultsAndMap>

              <MapToggleHolder>
                <Button
                  _focus={{
                    boxShadow: "none",
                  }}
                  _hover={{
                    backgroundColor: "myGray.50",
                  }}
                  _active={{
                    backgroundColor: "myGray.300",
                  }}
                  bg="white"
                  fontWeight="501"
                  height="2.25rem"
                  fontSize="0.875rem"
                  borderRadius="20px"
                  paddingX="1.1rem"
                  color="myGray.200"
                  variant="outline"
                  onClick={() => {
                    if (showMap) {
                      clientAnalytics.track("Map turned off");
                      setShowMap(false);
                    } else {
                      clientAnalytics.track("Map turned on");
                      setShowMap(true);
                    }
                  }}
                  leftIcon={showMap ? <BsViewList /> : <MdMap />}
                  borderColor={"myGray.100"}
                >
                  {showMap ? "Show listings" : "Show map"}
                </Button>
              </MapToggleHolder>
              {/* Toggle Map and List */}
            </>
          )}
        </Formik>
      </StaticHolder>
    </MainHolder>
    <AuthModal
      header={authHeader}
      onClose={onAuthBoxClose}
      isOpen={isAuthBoxOpen}
    />
    <Modal
      closeOnOverlayClick={false}
      isCentered
      isOpen={isSavedSearchOpen}
      onClose={onSavedSearchClose}
    >
      <ModalOverlay />
      <ModalContent
        borderRadius={4}
        // width={{ base: "25rem", md: "50rem" }}
        // minHeight="30rem"
        maxW="56rem"
        h="auto"
      >
        <ModalHeader>We've saved it for you!</ModalHeader>
        <ModalCloseButton
          _focus={{
            boxShadow: "none",
          }}
        />
        {savedSearchData && (
          <Formik
            initialValues={{
              title: savedSearchData?.title || [],
              frequency: savedSearchData?.frequency || "",
            }}
            onSubmit={async (values, { setSubmitting }) => {
              savedSearchUpdate.mutate(values);

              setSubmitting(false);
            }}
          >
            {({
              isSubmitting,
              isValid,
              handleChange,
              values,
              handleSubmit,
              errors,
              touched,
              setFieldValue,
            }) => (
              <form>
                <ModalBody>
                  <ModalBodyText>
                    We'll let you know when properties of interest arrive on
                    Zonado. In the mean time, feel free to make changes below
                    and access all your saved seaches on the{" "}
                    <Link href="/saved">
                      <Button
                        fontWeight={"500"}
                        verticalAlign={"inherit"}
                        paddingY="0px"
                        marginY="0px"
                        display="inline"
                        variant="link"
                        colorScheme="green"
                      >
                        saved searches
                      </Button>
                    </Link>{" "}
                    page.
                  </ModalBodyText>
                  <SSDetails>
                    <BoldedSpan>Saved criteria:</BoldedSpan>{" "}
                    {savedSearchData?.detailsArray?.join(" · ")}
                  </SSDetails>

                  <Flex
                    w="100%"
                    justifyContent={"space-between"}
                    flexWrap={"wrap"}
                    mt="1rem"
                    gridRowGap="1rem"
                    gridColumnGap="1rem"
                  >
                    <Box flexGrow={1}>
                      <MyFormLabel htmlFor="title">
                        Saved search name
                      </MyFormLabel>
                      {/* <Input
                                              focusBorderColor="green.500" id="title" name="title"
                                              variant="flushed" placeholder="Saved search name" defaultValue={savedSearchData?.title} /> */}
                      <Field name="title">
                        {({ field, form }) => (
                          <Input
                            {...field}
                            {...form}
                            autoFocus
                            focusBorderColor="green.500"
                            id="title"
                            defaultValue={values["title"]}
                            placeholder="Saved search name"
                          />
                        )}
                      </Field>
                    </Box>
                    <Box w="10rem" flexGrow={1}>
                      <LabelAndTooltip>
                        <MyFormLabel htmlFor="frequency">
                          Frequency
                        </MyFormLabel>
                        <ToolTipCreator body="How frequently would you like to receive the alerts? Instant means you'll be alerted right away. Daily or weekly means you'll receive a summary message at the end of the day or week." />
                      </LabelAndTooltip>

                      <ChakraSelect
                        defaultValue={"Daily"}
                        id="frequency"
                        onChange={(e) => {
                          updateListingFilters({
                            ...queryState,
                            frequency: e.target.value,
                          });
                          // setFieldValue("frequency", e.target.value);
                        }}
                        focusBorderColor="green.500"
                      >
                        {SavedSearchFrequencyOptions.map((i, index) => (
                          <option key={index} value={i["value"]}>
                            {i["label"]}
                          </option>
                        ))}
                      </ChakraSelect>
                    </Box>
                  </Flex>
                </ModalBody>

                <ModalFooter>
                  <ButtonGroup size="sm">
                    <Button
                      colorScheme="green"
                      onClick={() => handleSubmit()}
                      type="button"
                      isDisabled={!isValid || isSubmitting}
                      isLoading={updateStatus == "loading"}
                      loadingText="Updating..."
                    >
                      Update
                    </Button>
                  </ButtonGroup>
                </ModalFooter>
              </form>
            )}
          </Formik>
        )}
      </ModalContent>
    </Modal>
  </>);
};

export default Listings;

// When true, causes a search badge to be added to BigSearch
let addLocationToSearchBadges = false;

export const BigSearch = ({
  inDrawer,
  isFilterDrawerOpen,
  setFieldValue,
  staticType,
  setStaticStatus,
  staticStatus,
  values,
  panTo,
  bigSearchBadges,
  setBigSearchBadges,
  mapBoundUpdater,
  actualBoundUpdater,
  queryState,
  setQueryState,
}) => {
  const {
    ready,
    value,
    suggestions: { status, data, loading },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      types: ["geocode"],
      componentRestrictions: { country: "ca" },
    },
  });
  const router = useRouter();

  const [searchBoxActive, setSearchBoxActive] = useState(false);
  function useOutsideAlerter(ref: MutableRefObject<any>) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && ref.current.contains(event.target)) {
          setSearchBoxActive(true);
        } else if (ref.current && !ref.current.contains(event.target)) {
          setSearchBoxActive(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const searchBox = createRef<HTMLInputElement>();
  const useKeyPress = function (
    targetKey: string,
    ref: RefObject<HTMLInputElement | null>
  ) {
    const [keyPressed, setKeyPressed] = useState(false);

    function downHandler({ key }: { key: string }) {
      if (key === targetKey) {
        setKeyPressed(true);
      }
    }

    const upHandler = ({ key }: { key: string }) => {
      if (key === targetKey) {
        setKeyPressed(false);
      }
    };

    useEffect(() => {
      ref.current?.addEventListener("keydown", downHandler);
      ref.current?.addEventListener("keyup", upHandler);

      return () => {
        ref.current?.removeEventListener("keydown", downHandler);
        ref.current?.removeEventListener("keyup", upHandler);
      };
    });

    return keyPressed;
  };

  const downPress = useKeyPress("ArrowDown", searchBox);
  const upPress = useKeyPress("ArrowUp", searchBox);
  const enterPress = useKeyPress("Enter", searchBox);
  const [cursor, setCursor] = useState<number>(0);
  const [hovered, setHovered] = useState(undefined);
  const [selected, setSelected] = useState(undefined);

  const [typeOptionsArray, setTypeOptionsArray] = useState([]);

  let optionsArray = [];

  useEffect(() => {
    if (optionsArray.length && downPress) {
      setCursor((prevState) =>
        prevState < optionsArray.length - 1 ? prevState + 1 : 0
      );
    }
  }, [downPress]);
  useEffect(() => {
    if (optionsArray.length && upPress) {
      setCursor((prevState) => (prevState > 0 ? prevState - 1 : prevState));
    }
  }, [upPress]);
  useEffect(() => {
    // if (optionsArray.length && enterPress || optionsArray.length && hovered) {
    if (optionsArray.length && enterPress) {
      handleSelect(optionsArray[cursor]);
    }
  }, [cursor, enterPress]);
  useEffect(() => {
    if (optionsArray.length && hovered) {
      setCursor(optionsArray.indexOf(hovered));
    }
  }, [hovered]);

  const handleInput = (e) => {
    // setAddress(e);

    setValue(e);
    // Make search box active if it isn't
    !searchBoxActive ? setSearchBoxActive(true) : null;

    let lowererd = e.toLowerCase();
    let matchingTypes = propertyTypeOptions.filter((t) =>
      t["value"].toLowerCase().includes(lowererd)
    );
    let matchingSubTypes = subTypeOptions.filter((t) =>
      t["value"].toLowerCase().includes(lowererd)
    );

    // typeOptionsArray.push(...matchingTypes, ...matchingSubTypes)
    setTypeOptionsArray([...matchingTypes, ...matchingSubTypes]);
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const [tempSearchText, setTempSearchText] = useState("");
  const [badgeSetBySystem, setBadgeSetBySystem] = useState(false);

  const handleSelect = async (element, setBySystem = false) => {
    // return
    const { description, place_id } = element;
    let placeIdsCopy = Array.isArray(values["placeId"])
      ? [...values["placeId"]]
      : [];
    placeIdsCopy.push(element["place_id"]);
    // setFieldValue('placeId', placeIdsCopy)

    setBigSearchBadges([
      ...bigSearchBadges,
      { description: description.replace(", Canada", ""), place_id },
    ]);
    setTempSearchText("");
    setSearchBoxActive(false);
    // setValue(description, false);
    // setdescription(description)
    // clearSuggestions();

    try {
      const results = await getGeocode({ address: description });
      // const { lat, lng } = await getLatLng(results[0]);
      let boundObj = results[0]["geometry"]["bounds"]
        ? results[0]["geometry"]["bounds"]
        : results[0]["geometry"]["viewport"];

      // let viewport = results[0]['geometry']['viewPort'];

      let ne = boundObj.getNorthEast();
      let sw = boundObj.getSouthWest();
      actualBoundUpdater({ ne, sw }, setBySystem);

      // set up the pan to function
      panTo(results[0]["geometry"]);

      // const addressComponents = results[0]['address_components']

      // // Map through the address components, find the object where the types array contains 'locality' and use the long_name of that object to set the city
      // addressComponents.map(i => {
      //     if (i['types'].includes('locality')) {
      //         setCityData(i['long_name']);
      //     }

      // })
    } catch (error) {
      clientError(error);
    }
  };

  // If there is a province slug in the route, get the province name and set it as the location value passed to the usePlacesAutocomplete library
  useEffect(() => {
    if (!staticStatus) return;
    // When drawer is open, BigSearch remounts and the useEffect runs which duplicates the search badge, returning here prevents that
    if (isFilterDrawerOpen) return;
    const provinceSlugInRoute = provinceSlugs.find((slug) => {
      return (
        slug.slug.toUpperCase() ==
          (String(router.query.id).toUpperCase() as string) ||
        slug.value == router.query.province
      );
    });

    const cityInRoute = Array.isArray(queryState.city)
      ? null
      : (queryState.city as string) || (router.query.city as string);

    if (!!provinceSlugInRoute && !cityInRoute) {
      const provinceName = provinceSlugInRoute["value"];
      setValue(provinceName);
      addLocationToSearchBadges = true;
    } else if (!!cityInRoute) {
      setValue(cityInRoute);
      addLocationToSearchBadges = true;
    }
  }, [queryState["province"]]);
  /* 
  When matching location data has been received from the usePlacesAutocomplete hook, the effect function is run.
  */
  useEffect(() => {
    //faa We want the effect to run only the first time the location data for the province is returned and when the data is not empty
    if (addLocationToSearchBadges && !!data.length) {
      setBadgeSetBySystem(true);
      // Since filtering is by province name, get the most general location data - the one with the fewest matching terms, which is typically the exact province location data
      let exactProvinceLocation = data[0];
      data.forEach((currentValue, index) => {
        if (currentValue.terms.length < exactProvinceLocation.terms.length) {
          exactProvinceLocation = currentValue;
        }
      });
      const { description, place_id } = exactProvinceLocation;
      handleSelect({ description, place_id }, true);
      // On the initial render, after using the province slug in route to set a search badge, don't add the search badge again
      addLocationToSearchBadges = false;
    }
  }, [data]);

  const placeRemover = (index) => {
    // let placeIdsCopy = [...values['placeId']];
    let bigBadgesCopy = [...bigSearchBadges];
    let actualBoundsCopy = [...queryState["bounds"]["actualBounds"]];

    // placeIdsCopy.splice(index, 1)
    bigBadgesCopy.splice(index, 1);
    actualBoundsCopy.splice(index, 1);

    // setFieldValue('placeId', placeIdsCopy)
    setBigSearchBadges(bigBadgesCopy);

    const { bounds, page, ...rest } = queryState;

    if (staticStatus) {
      setStaticStatus(false);
      router.push({
        pathname: "/listings",
        query: {
          ...queryState,
          city: [],
          province: [],
        },
      });
      return;
    }

    // Remove actual bounds
    let newBoundObj = {
      // Put in the other keys
      ...queryState["bounds"],
      actualBounds: actualBoundsCopy,
    };
    setQueryState({
      bounds: newBoundObj,
      // page: [],
      ...rest,
    });
  };

  data.forEach((element) => {
    const { types } = element;
    if (
      types.filter((value) => ["premise", "route"].includes(value)).length == 0
    ) {
      optionsArray.push(element);
    }
  });

  const SuggestionItem = ({ item, active, setSelected, setHovered, type }) => (
    <div role="row">
      <StyledRow
        active={active}
        // tabIndex={index + 1}
        onMouseEnter={() => setHovered(item)}
        onMouseLeave={() => setHovered(undefined)}
        onClick={() => {
          handleSelect(item);
        }}
      >
        <Flex>
          <ContentCell role="gridcell">
            <IconSpan>
              {type == "place" && <FaMapMarkerAlt size="20px" />}
              {type == "propertyType" && <RiBuilding2Fill size="20px" />}
            </IconSpan>

            <BoldSpan>
              {type == "place" && item["structured_formatting"]["main_text"]}
              {type == "propertyType" && item["value"]}
            </BoldSpan>

            <TextSpan>
              {type == "place" &&
                item["structured_formatting"]["secondary_text"]?.split(",")[0]}
              {type == "propertyType" &&
                item?.group?.length > 0 &&
                item["group"]}
            </TextSpan>
          </ContentCell>
          <SpacerCell role="gridcell"></SpacerCell>
        </Flex>
      </StyledRow>
    </div>
  );

  return (
    <SearchWrapper ref={wrapperRef}>
      <InnerSearchWrapper inDrawer={inDrawer}>
        <Searcher
          role="search"
          ref={searchBox}
          onSubmit={(e) => e.preventDefault()}
        >
          {bigSearchBadges?.length == 0 && (
            <SearchIcon>
              <MdSearch
                // padding="8px"
                color="#125f3f"
                size="24px"
              />
            </SearchIcon>
          )}
          <BadgeFlex active={searchBoxActive}>
            {searchBoxActive ? (
              bigSearchBadges?.map((sb, index) => (
                <Flex key={index} alignItems="center">
                  <Tag
                    size={"sm"}
                    key={index}
                    rounded="md"
                    variant="outline"
                    bg="white"
                    color="green.500"
                    // colorScheme="green.500"
                    fontWeight={400}
                  >
                    <TagLabel>{sb["description"]}</TagLabel>
                    <TagCloseButton
                      type="button"
                      onSubmit={(e) => e.preventDefault()}
                      onClick={() => {
                        placeRemover(index);
                      }}
                    />
                  </Tag>
                </Flex>
              ))
            ) : (
              <>
                {bigSearchBadges?.length > 0 && (
                  <Tag
                    size={"sm"}
                    rounded="md"
                    variant="outline"
                    bg="white"
                    color="green.500"
                    // colorScheme="green.500"
                    fontWeight={400}
                  >
                    <TagLabel>{bigSearchBadges[0]["description"]}</TagLabel>
                    <TagCloseButton
                      type="button"
                      onSubmit={(e) => e.preventDefault()}
                      onClick={() => {
                        placeRemover(0);
                      }}
                    />
                  </Tag>
                )}

                {bigSearchBadges?.length > 1 && (
                  <Tag
                    size={"sm"}
                    rounded="md"
                    variant="outline"
                    flexShrink={0}
                    bg="white"
                    color="green.500"
                    // colorScheme="green.500"
                    fontWeight={400}
                  >
                    <TagLabel>+{bigSearchBadges?.length - 1} more</TagLabel>
                  </Tag>
                )}
              </>
            )}
            <SearchText
              badges={bigSearchBadges?.length > 0}
              value={tempSearchText}
              onChange={(e) => {
                setTempSearchText(e.target.value);
                handleInput(e.target.value);
              }}
              placeholder={
                bigSearchBadges?.length == 0
                  ? "Search for regions"
                  : "Add more..."
              }
            />
          </BadgeFlex>
          {searchBoxActive &&
            tempSearchText?.length > 0 &&
            (optionsArray?.length > 0 || typeOptionsArray?.length > 0) && (
              <Suggestions>
                <div role="grid">
                  {optionsArray.map((i, index) => (
                    <SuggestionItem
                      key={i["place_id"]}
                      active={index === cursor}
                      item={i}
                      type={"place"}
                      setSelected={setSelected}
                      setHovered={setHovered}
                    />
                  ))}

                  {/* {typeOptionsArray.map((j, index) => (
                                    <SuggestionItem
                                        key={j['value']}
                                        active={index === cursor}
                                        item={j}
                                        type={"propertyType"}
                                        setSelected={setSelected}
                                        setHovered={setHovered} />
                                    

                                ))} */}
                </div>
              </Suggestions>
            )}
          {/* <ExpandButton 
                        type="button"
                    onClick={() => { 
                        setSearchBoxActive(true);
                    }} title="Advanced search">
                        <MdArrowDropDown size="24px" />
                    </ExpandButton> */}
        </Searcher>
      </InnerSearchWrapper>
    </SearchWrapper>
  );
};
